"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLoggerConf = exports.Logger = exports.initCustomLogger = void 0;
/* tslint:disable */
/* eslint:disable */
/**
* @typedef {string} Url
*/
/**
* @typedef {string} GUID
*/
/**
* @typedef {number} DateTime
*/
var dummy;
var defaultConfig = { endpoint: 'contacts' };
var init = function (webOrMobileLogger) { return function (userConfig) {
    if (userConfig === void 0) { userConfig = {}; }
    var defaults = userConfig.defaults, restOfConfig = __rest(userConfig, ["defaults"]);
    var config = __assign(__assign({}, defaultConfig), restOfConfig);
    var factoryInstance = typeof webOrMobileLogger.factory === 'function' ? webOrMobileLogger.factory(config) : webOrMobileLogger;
    var logger = getLogger(factoryInstance);
    return defaults ? logger.util.updateDefaults(defaults) : logger;
}; };
exports.initCustomLogger = function (factoryInstance) { return getLogger(factoryInstance); };
var getLogger = function (biLoggerClientFactoryInstance) {
    return new Logger(biLoggerClientFactoryInstance);
};
var Logger = /** @class */ (function () {
    function Logger(biLoggerClientFactoryInstance) {
        var _this = this;
        this.biLoggerClientFactoryInstance = biLoggerClientFactoryInstance;
        this.util = {
            updateDefaults: function (defaults) {
                _this.biLoggerClientFactoryInstance.updateDefaults(defaults);
                return _this;
            },
            log: function (logParams, context) {
                return _this.bi.log(logParams, context);
            }
        };
        biLoggerClientFactoryInstance
            .updateDefaults({ src: 27 });
        this.bi = biLoggerClientFactoryInstance.logger({ endpoint: 'contacts' });
    }
    ;
    /**
    * @typedef {Object} contactsClickDiscardReplyParams
    * @property {string} contact_id - contact identifier
    * @property {number} contactsDisplayed - null
    * @property {string} group - the clicked contacts tab
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - null
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts -> click Discard reply. Evid: 189.
     * Event description: Discard reply.
    
     * contact_id - Type: string. Desc: contact identifier
     *
     * contactsDisplayed - Type: numeric.
     *
     * group - Type: string. Desc: the clicked contacts tab
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid.
     *
     * pageView - Type: string.
     * @param {contactsClickDiscardReplyParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsClickDiscardReply = function (params) {
        return this.bi.log(__assign({ evid: 189 }, params));
    };
    /**
    * @typedef {Object} contactsContactViewAddChangeNewSubscriptionParams
    * @property {string} action - {add,change}
    * @property {number} contactsDisplayed - --
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - --
    * @property {string} origin - what app opened the edit contact modal
    * @property {string} pageView - --
    * @property {string} subscription_status - subscribed/unsubscribed
    **/
    /**
     * Name: contacts -> contact view -> add/change new subscription. Evid: 159.
     * Event description: user add/change his contact subscription.
    
     * action - Type: string. Desc: {add,change}
     *
     * contactsDisplayed - Type: numeric. Desc: --
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: --
     *
     * origin - Type: string. Desc: what app opened the edit contact modal
     *
     * pageView - Type: string. Desc: --
     *
     * subscription_status - Type: string. Desc: subscribed/unsubscribed
     * @param {contactsContactViewAddChangeNewSubscriptionParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsContactViewAddChangeNewSubscription = function (params) {
        return this.bi.log(__assign({ evid: 159 }, params));
    };
    /**
    * @typedef {Object} contactsOpenActionsMenuInContactCardPageParams
    * @property {number} contactsDisplayed - deprecated
    * @property {boolean} hasContacts - deprecated
    * @property {GUID} msid - msid
    * @property {string} pageView - deprecated
    **/
    /**
     * Name: contacts -> open actions menu in contact card page. Evid: 175.
     * Event description: user clicks on actions and opens the actions dialog.
    
     * contactsDisplayed - Type: numeric. Desc: deprecated
     *
     * hasContacts - Type: bool. Desc: deprecated
     *
     * msid - Type: guid. Desc: msid
     *
     * pageView - Type: string. Desc: deprecated
     * @param {contactsOpenActionsMenuInContactCardPageParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsOpenActionsMenuInContactCardPage = function (params) {
        return this.bi.log(__assign({ evid: 175 }, params));
    };
    /**
    * @typedef {Object} contactsAttachmentsToastIsDisplayedParams
    * @property {string} attachmentId - attachment id
    * @property {string} contactId - contact id
    * @property {number} contactsDisplayed - deprecated
    * @property {boolean} hasContacts - deprecated
    * @property {GUID} msid - meta site id
    * @property {string} name - e.g app not responding
    * @property {string} pageView - deprecated
    **/
    /**
     * Name: contacts -> attachments -> toast is displayed. Evid: 218.
     * Event description: a toast is displayed (contacts not responding).
    
     * attachmentId - Type: string. Desc: attachment id
     *
     * contactId - Type: string. Desc: contact id
     *
     * contactsDisplayed - Type: numeric. Desc: deprecated
     *
     * hasContacts - Type: bool. Desc: deprecated
     *
     * msid - Type: guid. Desc: meta site id
     *
     * name - Type: string. Desc: e.g app not responding
     *
     * pageView - Type: string. Desc: deprecated
     * @param {contactsAttachmentsToastIsDisplayedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsAttachmentsToastIsDisplayed = function (params) {
        return this.bi.log(__assign({ evid: 218 }, params));
    };
    /**
    * @typedef {Object} contactsContactViewSaveAndCreateAnotherInEditWindowParams
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - msid
    * @property {string} origin - what app opened the edit contact modal
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts -> contact view -> save and create another in edit window. Evid: 280.
     * Event description: contacts -> contact view -> save and create another in edit window.
    
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: what app opened the edit contact modal
     *
     * pageView - Type: string.
     * @param {contactsContactViewSaveAndCreateAnotherInEditWindowParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsContactViewSaveAndCreateAnotherInEditWindow = function (params) {
        return this.bi.log(__assign({ evid: 280 }, params));
    };
    /**
    * @typedef {Object} contactsContactedMeParams
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - null
    * @property {string} pageView - null
    * @property {number} tagcount - null
    **/
    /**
     * Name: contacts -> contacted me. Evid: 107.
    
    
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid.
     *
     * pageView - Type: string.
     *
     * tagcount - Type: numeric.
     * @param {contactsContactedMeParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsContactedMe = function (params) {
        return this.bi.log(__assign({ evid: 107 }, params));
    };
    /**
    * @typedef {Object} importContactsCancelGmailAccountSelectionParams
    * @property {GUID} appstreamid - unique identifier of import session
    * @property {number} contactsDisplayed - null
    * @property {string} errorReason - errorReason
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - msid
    * @property {string} origin - The hosting application
    * @property {string} pageView - pageView
    **/
    /**
     * Name: import contacts -> Cancel Gmail Account Selection. Evid: 266.
     * Event description: Cancel Gmail Account Selection.
    
     * appstreamid - Type: guid. Desc: unique identifier of import session
     *
     * contactsDisplayed - Type: numeric.
     *
     * errorReason - Type: string. Desc: errorReason
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: The hosting application
     *
     * pageView - Type: string. Desc: pageView
     * @param {importContactsCancelGmailAccountSelectionParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.importContactsCancelGmailAccountSelection = function (params) {
        return this.bi.log(__assign({ evid: 266 }, params));
    };
    /**
    * @typedef {Object} importContactsClickOnBackNextStepGmailImportParams
    * @property {GUID} appstreamid - unique identifier of import session
    * @property {number} contactsDisplayed - contactsDisplayed
    * @property {string} direct_from - 'Subscribers'/'Label'
    * @property {string} direction - 'back'/'next'
    * @property {boolean} hasContacts - hasContacts
    * @property {GUID} msid - msid
    * @property {string} origin - The hosting application
    * @property {string} package_group - package_group
    * @property {string} package_id - package_name
    * @property {string} pageView - pageView
    **/
    /**
     * Name: import contacts -> click on back/ next step - Gmail Import. Evid: 234.
     * Event description: click on back/ next step.
    
     * appstreamid - Type: guid. Desc: unique identifier of import session
     *
     * contactsDisplayed - Type: numeric. Desc: contactsDisplayed
     *
     * direct_from - Type: string. Desc: 'Subscribers'/'Label'
     *
     * direction - Type: string. Desc: 'back'/'next'
     *
     * hasContacts - Type: bool. Desc: hasContacts
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: The hosting application
     *
     * package_group - Type: string. Desc: package_group
     *
     * package_id - Type: string. Desc: package_name
     *
     * pageView - Type: string. Desc: pageView
     * @param {importContactsClickOnBackNextStepGmailImportParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.importContactsClickOnBackNextStepGmailImport = function (params) {
        return this.bi.log(__assign({ evid: 234 }, params));
    };
    /**
    * @typedef {Object} contactsClickOnCloseManageContactsTip241Params
    * @property {string} clickType - 'dismiss', 'got it'
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - meta site id
    * @property {string} pageView - inbox/ workflows/contacts-list....
    **/
    /**
     * Name: contacts -> click to close 'add image to contacts' tip. Evid: 241.
     * Event description: click on close 'add image to contacts' tip.
    
     * clickType - Type: string. Desc: 'dismiss', 'got it'
     *
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: meta site id
     *
     * pageView - Type: string. Desc: inbox/ workflows/contacts-list....
     * @param {contactsClickOnCloseManageContactsTip241Params} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsClickOnCloseManageContactsTip241 = function (params) {
        return this.bi.log(__assign({ evid: 241 }, params));
    };
    /**
    * @typedef {Object} contactsEditContactSiteMembersPopupParams
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - null
    * @property {string} pageView - null
    * @property {string} type - null
    **/
    /**
     * Name: contacts -> edit contact -> site members popup. Evid: 126.
    
    
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid.
     *
     * pageView - Type: string.
     *
     * type - Type: string.
     * @param {contactsEditContactSiteMembersPopupParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsEditContactSiteMembersPopup = function (params) {
        return this.bi.log(__assign({ evid: 126 }, params));
    };
    /**
    * @typedef {Object} contactsErrorOnFieldParams
    * @property {number} contactsDisplayed - null
    * @property {string} fieldName - the field which triggered the error
    * @property {string} fieldType - type of the field which triggered the error
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - site id
    * @property {string} name - error description
    * @property {string} origin - the page on which the error is presented
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts -> error on field. Evid: 193.
     * Event description: error tooltip on field in custom fields.
    
     * contactsDisplayed - Type: numeric.
     *
     * fieldName - Type: string. Desc: the field which triggered the error
     *
     * fieldType - Type: string. Desc: type of the field which triggered the error
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: site id
     *
     * name - Type: string. Desc: error description
     *
     * origin - Type: string. Desc: the page on which the error is presented
     *
     * pageView - Type: string.
     * @param {contactsErrorOnFieldParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsErrorOnField = function (params) {
        return this.bi.log(__assign({ evid: 193 }, params));
    };
    /**
    * @typedef {Object} contactsDeleteLabelClickParams
    * @property {number} contactsDisplayed - deprecated
    * @property {boolean} hasContacts - deprecated
    * @property {GUID} msid - metasite id
    * @property {string} name - deprecated
    * @property {string} origin - deprecated
    * @property {string} page_display - deprecated
    * @property {string} pageView - deprecated
    **/
    /**
     * Name: contacts -> delete label click. Evid: 145.
     * Event description: user clicks on delete label.
    
     * contactsDisplayed - Type: numeric. Desc: deprecated
     *
     * hasContacts - Type: bool. Desc: deprecated
     *
     * msid - Type: guid. Desc: metasite id
     *
     * name - Type: string. Desc: deprecated
     *
     * origin - Type: string. Desc: deprecated
     *
     * page_display - Type: string. Desc: deprecated
     *
     * pageView - Type: string. Desc: deprecated
     * @param {contactsDeleteLabelClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsDeleteLabelClick = function (params) {
        return this.bi.log(__assign({ evid: 145 }, params));
    };
    /**
    * @typedef {Object} contactsAdvancedFiltersSavingUpdatingConfirmationParams
    * @property {string} action - 'save'/'update'
    * @property {number} contactsDisplayed - null
    * @property {string} filterID - filterID
    * @property {string} filterName - filterName
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - metasite id
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts ->Advanced Filters - saving/updating confirmation. Evid: 256.
     * Event description: saving confirmation on Save/update pop-up.
    
     * action - Type: string. Desc: 'save'/'update'
     *
     * contactsDisplayed - Type: numeric.
     *
     * filterID - Type: string. Desc: filterID
     *
     * filterName - Type: string. Desc: filterName
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: metasite id
     *
     * pageView - Type: string.
     * @param {contactsAdvancedFiltersSavingUpdatingConfirmationParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsAdvancedFiltersSavingUpdatingConfirmation = function (params) {
        return this.bi.log(__assign({ evid: 256 }, params));
    };
    /**
    * @typedef {Object} contactsFullPageAssigneeClickParams
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - msid
    * @property {string} pageView - null
    **/
    /**
     * Name: Contacts - Full Page - Assignee click. Evid: 286.
     * Event description: Contacts - Full Page - avatar click.
    
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: msid
     *
     * pageView - Type: string.
     * @param {contactsFullPageAssigneeClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsFullPageAssigneeClick = function (params) {
        return this.bi.log(__assign({ evid: 286 }, params));
    };
    /**
    * @typedef {Object} contactsFitlerContactsRequestParams
    * @property {number} contactsDisplayed - null
    * @property {number} count - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - null
    * @property {string} pageView - null
    * @property {string} query - null
    * @property {string} type - null
    **/
    /**
     * Name: contacts -> fitler contacts request. Evid: 132.
    
    
     * contactsDisplayed - Type: numeric.
     *
     * count - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid.
     *
     * pageView - Type: string.
     *
     * query - Type: string.
     *
     * type - Type: string.
     * @param {contactsFitlerContactsRequestParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsFitlerContactsRequest = function (params) {
        return this.bi.log(__assign({ evid: 132 }, params));
    };
    /**
    * @typedef {Object} importContactsGmailAccountSelectedParams
    * @property {GUID} appstreamid - unique identifier of import session
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - msid
    * @property {number} numberOfContacts - from gmail account
    * @property {string} origin - The hosting application
    * @property {string} package_group - package_group
    * @property {string} package_id - package_name
    * @property {string} pageView - null
    **/
    /**
     * Name: import contacts -> gmail account selected. Evid: 227.
     * Event description: gmail account selected.
    
     * appstreamid - Type: guid. Desc: unique identifier of import session
     *
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: msid
     *
     * numberOfContacts - Type: numeric. Desc: from gmail account
     *
     * origin - Type: string. Desc: The hosting application
     *
     * package_group - Type: string. Desc: package_group
     *
     * package_id - Type: string. Desc: package_name
     *
     * pageView - Type: string.
     * @param {importContactsGmailAccountSelectedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.importContactsGmailAccountSelected = function (params) {
        return this.bi.log(__assign({ evid: 227 }, params));
    };
    /**
    * @typedef {Object} contactsWidgetOpenContactListParams
    * @property {GUID} contactId - contactId
    * @property {number} contactsDisplayed - contactsDisplayed
    * @property {boolean} hasContacts - hasContacts
    * @property {GUID} msid - msid
    * @property {string} pageView - pageView
    **/
    /**
     * Name: Contacts - Widget -  Open Contact List. Evid: 297.
     * Event description: Contacts - Widget -  Open Contact List.
    
     * contactId - Type: guid. Desc: contactId
     *
     * contactsDisplayed - Type: numeric. Desc: contactsDisplayed
     *
     * hasContacts - Type: bool. Desc: hasContacts
     *
     * msid - Type: guid. Desc: msid
     *
     * pageView - Type: string. Desc: pageView
     * @param {contactsWidgetOpenContactListParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsWidgetOpenContactList = function (params) {
        return this.bi.log(__assign({ evid: 297 }, params));
    };
    /**
    * @typedef {Object} contactsAdvancedFiltersCancelChangesParams
    * @property {number} contactsDisplayed - null
    * @property {string} filterID - filterID
    * @property {string} filterName - filterName
    * @property {boolean} hasContacts - null
    * @property {boolean} isModified - isModified
    * @property {GUID} msid - metasite id
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts ->Advanced Filters - cancel changes. Evid: 265.
     * Event description: Advanced Filters - cancel changes.
    
     * contactsDisplayed - Type: numeric.
     *
     * filterID - Type: string. Desc: filterID
     *
     * filterName - Type: string. Desc: filterName
     *
     * hasContacts - Type: bool.
     *
     * isModified - Type: bool. Desc: isModified
     *
     * msid - Type: guid. Desc: metasite id
     *
     * pageView - Type: string.
     * @param {contactsAdvancedFiltersCancelChangesParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsAdvancedFiltersCancelChanges = function (params) {
        return this.bi.log(__assign({ evid: 265 }, params));
    };
    /**
    * @typedef {Object} contactsDeleteLabelConfirmationParams
    * @property {number} contactsDisplayed - deprecated
    * @property {boolean} hasContacts - deprecated
    * @property {GUID} msid - metasite id
    * @property {string} name - deprecated
    * @property {string} origin - deprecated
    * @property {string} page_display - deprecated
    * @property {string} pageView - deprecated
    * @property {string} user_decision - deprecated
    **/
    /**
     * Name: contacts -> delete label confirmation. Evid: 146.
     * Event description: user clicks confirm in the delete label pop-up.
    
     * contactsDisplayed - Type: numeric. Desc: deprecated
     *
     * hasContacts - Type: bool. Desc: deprecated
     *
     * msid - Type: guid. Desc: metasite id
     *
     * name - Type: string. Desc: deprecated
     *
     * origin - Type: string. Desc: deprecated
     *
     * page_display - Type: string. Desc: deprecated
     *
     * pageView - Type: string. Desc: deprecated
     *
     * user_decision - Type: string. Desc: deprecated
     * @param {contactsDeleteLabelConfirmationParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsDeleteLabelConfirmation = function (params) {
        return this.bi.log(__assign({ evid: 146 }, params));
    };
    /**
    * @typedef {Object} contactsCreateAContactWarningClickOnViewContactParams
    * @property {string} contactId - contact id
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - meta site id
    * @property {string} origin - view contact
    * @property {string} pageView - crm tab name
    **/
    /**
     * Name: contacts -> create a contact-> duplication warning displayed. Evid: 272.
     * Event description: user is being displayed with a duplication warning on creating new contact.
    
     * contactId - Type: string. Desc: contact id
     *
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: meta site id
     *
     * origin - Type: string. Desc: view contact
     *
     * pageView - Type: string. Desc: crm tab name
     * @param {contactsCreateAContactWarningClickOnViewContactParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsCreateAContactWarningClickOnViewContact = function (params) {
        return this.bi.log(__assign({ evid: 272 }, params));
    };
    /**
    * @typedef {Object} contactsOpenPrivacyAndGdprParams
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - metasite id
    * @property {string} origin - contacts-list, contact-card-actions, contacts-card-labels
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts -> open privacy and GDPR. Evid: 198.
     * Event description: user clicks privacy and GDPR in action menu.
    
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: metasite id
     *
     * origin - Type: string. Desc: contacts-list, contact-card-actions, contacts-card-labels
     *
     * pageView - Type: string.
     * @param {contactsOpenPrivacyAndGdprParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsOpenPrivacyAndGdpr = function (params) {
        return this.bi.log(__assign({ evid: 198 }, params));
    };
    /**
    * @typedef {Object} importContactsMarkAsSubscribersLearnMoreParams
    * @property {GUID} appstreamid - unique identifier of import session
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {string} import_type - 'gmail account' / 'csv file'
    * @property {GUID} msid - msid
    * @property {string} origin - The hosting application
    * @property {string} package_group - package_group
    * @property {string} package_id - package_name
    * @property {string} pageView - null
    **/
    /**
     * Name: import contacts -> Mark as Subscribers -  Learn More. Evid: 221.
     * Event description: Mark as Subscribers -  Learn More -  click.
    
     * appstreamid - Type: guid. Desc: unique identifier of import session
     *
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * import_type - Type: string. Desc: 'gmail account' / 'csv file'
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: The hosting application
     *
     * package_group - Type: string. Desc: package_group
     *
     * package_id - Type: string. Desc: package_name
     *
     * pageView - Type: string.
     * @param {importContactsMarkAsSubscribersLearnMoreParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.importContactsMarkAsSubscribersLearnMore = function (params) {
        return this.bi.log(__assign({ evid: 221 }, params));
    };
    /**
    * @typedef {Object} contactsCustomFieldsCancelOnCustomFieldWindowParams
    * @property {string} action - rename, add
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - site id
    * @property {string} origin - edit contact, new contact, manage custom fields...
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts -> custom fields -> cancel on Custom Field Window. Evid: 212.
     * Event description: close the window that is opened when user adds/renames a custom field.
    
     * action - Type: string. Desc: rename, add
     *
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: site id
     *
     * origin - Type: string. Desc: edit contact, new contact, manage custom fields...
     *
     * pageView - Type: string.
     * @param {contactsCustomFieldsCancelOnCustomFieldWindowParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsCustomFieldsCancelOnCustomFieldWindow = function (params) {
        return this.bi.log(__assign({ evid: 212 }, params));
    };
    /**
    * @typedef {Object} contactsSearchCompletedParams
    * @property {number} contactsDisplayed - deprecated
    * @property {string} text - deprecated (PII)
    * @property {boolean} hasContacts - deprecated
    * @property {GUID} msid - metasite id
    * @property {string} pageView - deprecated
    * @property {string} platform - deprecated
    * @property {string} referral - deprecated
    * @property {number} results - number of results
    **/
    /**
     * Name: contacts -> search completed. Evid: 129.
    
    
     * contactsDisplayed - Type: numeric. Desc: deprecated
     *
     * text - Type: string. Desc: deprecated (PII)
     *
     * hasContacts - Type: bool. Desc: deprecated
     *
     * msid - Type: guid. Desc: metasite id
     *
     * pageView - Type: string. Desc: deprecated
     *
     * platform - Type: string. Desc: deprecated
     *
     * referral - Type: string. Desc: deprecated
     *
     * results - Type: numeric. Desc: number of results
     * @param {contactsSearchCompletedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsSearchCompleted = function (params) {
        return this.bi.log(__assign({ evid: 129 }, params));
    };
    /**
    * @typedef {Object} importContactsClickOnDoneAfterImportCompletionParams
    * @property {GUID} appstreamid - unique identifier of import session
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - msid
    * @property {string} origin - The hosting application
    * @property {string} pageView - null
    **/
    /**
     * Name: import contacts -> click on Done after import completion. Evid: 245.
     * Event description: import contacts -> click on Done after import completion.
    
     * appstreamid - Type: guid. Desc: unique identifier of import session
     *
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: The hosting application
     *
     * pageView - Type: string.
     * @param {importContactsClickOnDoneAfterImportCompletionParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.importContactsClickOnDoneAfterImportCompletion = function (params) {
        return this.bi.log(__assign({ evid: 245 }, params));
    };
    /**
    * @typedef {Object} contactsAttachmentsDialogIsDisplayedParams
    * @property {string} contactId - contact id
    * @property {number} contactsDisplayed - deprecated
    * @property {string} file_type - file type
    * @property {boolean} hasContacts - deprecated
    * @property {GUID} msid - meta site id
    * @property {string} name - size limit, upload failed, delete
    * @property {string} pageView - deprecated
    **/
    /**
     * Name: contacts -> attachments -> dialog is displayed. Evid: 215.
     * Event description: a dialog is displayed (size limit warning, upload fail, approve delete).
    
     * contactId - Type: string. Desc: contact id
     *
     * contactsDisplayed - Type: numeric. Desc: deprecated
     *
     * file_type - Type: string. Desc: file type
     *
     * hasContacts - Type: bool. Desc: deprecated
     *
     * msid - Type: guid. Desc: meta site id
     *
     * name - Type: string. Desc: size limit, upload failed, delete
     *
     * pageView - Type: string. Desc: deprecated
     * @param {contactsAttachmentsDialogIsDisplayedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsAttachmentsDialogIsDisplayed = function (params) {
        return this.bi.log(__assign({ evid: 215 }, params));
    };
    /**
    * @typedef {Object} importContactsUploadMatchErrorsParams
    * @property {GUID} appstreamid - unique identifier of import session
    * @property {number} contactsDisplayed - null
    * @property {string} error_message - 'field titles are missing' / 'empty file' / 'file can't exceed 10,000 contacts' / 'duplicate field titles in the first row' /  'file can't exceed 4 Mb'
    * @property {string} error_type - 'error' / 'warning'
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - msid
    * @property {string} origin - The hosting application
    * @property {string} package_group - package_group
    * @property {string} package_id - package_name
    * @property {string} pageView - null
    * @property {string} phase_name - 'upload' / 'match'
    **/
    /**
     * Name: import contacts -> Upload /Match Errors. Evid: 222.
     * Event description: Upload /Match Errors.
    
     * appstreamid - Type: guid. Desc: unique identifier of import session
     *
     * contactsDisplayed - Type: numeric.
     *
     * error_message - Type: string. Desc: 'field titles are missing' / 'empty file' / 'file can't exceed 10,000 contacts' / 'duplicate field titles in the first row' /  'file can't exceed 4 Mb'
     *
     * error_type - Type: string. Desc: 'error' / 'warning'
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: The hosting application
     *
     * package_group - Type: string. Desc: package_group
     *
     * package_id - Type: string. Desc: package_name
     *
     * pageView - Type: string.
     *
     * phase_name - Type: string. Desc: 'upload' / 'match'
     * @param {importContactsUploadMatchErrorsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.importContactsUploadMatchErrors = function (params) {
        return this.bi.log(__assign({ evid: 222 }, params));
    };
    /**
    * @typedef {Object} contactsCloseFilterTipInContacts270Params
    * @property {number} contactsDisplayed - contact displayed
    * @property {boolean} hasContacts - bool
    * @property {GUID} msid - meta site id
    * @property {string} pageView - page view
    **/
    /**
     * Name: contacts ->close 'filter tip' in contacts. Evid: 270.
     * Event description: contacts ->close 'filter tip' in contacts banner.
    
     * contactsDisplayed - Type: numeric. Desc: contact displayed
     *
     * hasContacts - Type: bool. Desc: bool
     *
     * msid - Type: guid. Desc: meta site id
     *
     * pageView - Type: string. Desc: page view
     * @param {contactsCloseFilterTipInContacts270Params} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsCloseFilterTipInContacts270 = function (params) {
        return this.bi.log(__assign({ evid: 270 }, params));
    };
    /**
    * @typedef {Object} contactsRenameLabelClickParams
    * @property {number} contactsDisplayed - deprecated
    * @property {boolean} hasContacts - deprecated
    * @property {GUID} msid - metasite id
    * @property {string} name - deprecated
    * @property {string} origin - deprecated
    * @property {string} page_display - deprecated
    * @property {string} pageView - deprecated
    **/
    /**
     * Name: contacts -> rename label click. Evid: 137.
     * Event description: user clicks on rename label in manage labels dialog.
    
     * contactsDisplayed - Type: numeric. Desc: deprecated
     *
     * hasContacts - Type: bool. Desc: deprecated
     *
     * msid - Type: guid. Desc: metasite id
     *
     * name - Type: string. Desc: deprecated
     *
     * origin - Type: string. Desc: deprecated
     *
     * page_display - Type: string. Desc: deprecated
     *
     * pageView - Type: string. Desc: deprecated
     * @param {contactsRenameLabelClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsRenameLabelClick = function (params) {
        return this.bi.log(__assign({ evid: 137 }, params));
    };
    /**
    * @typedef {Object} contactsGroupSettingsClickParams
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - null
    * @property {string} name - null
    * @property {string} origin - null
    * @property {string} page_display - null
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts -> group settings click. Evid: 144.
    
    
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid.
     *
     * name - Type: string.
     *
     * origin - Type: string.
     *
     * page_display - Type: string.
     *
     * pageView - Type: string.
     * @param {contactsGroupSettingsClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsGroupSettingsClick = function (params) {
        return this.bi.log(__assign({ evid: 144 }, params));
    };
    /**
    * @typedef {Object} contactsClickOnImportContactsInContactsBannerParams
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - meta site id
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts ->click on 'Import Contacts' in contacts banner. Evid: 242.
     * Event description: contacts ->click on 'Import Contacts' in contacts banner.
    
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: meta site id
     *
     * pageView - Type: string.
     * @param {contactsClickOnImportContactsInContactsBannerParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsClickOnImportContactsInContactsBanner = function (params) {
        return this.bi.log(__assign({ evid: 242 }, params));
    };
    /**
    * @typedef {Object} exportContactsOpenParams
    * @property {number} contactsDisplayed - deprecated
    * @property {boolean} hasContacts - deprecated
    * @property {GUID} msid - null
    * @property {number} number_of_contacts - null
    * @property {string} pageView - deprecated
    * @property {string} source - null
    **/
    /**
     * Name: export contacts -> open. Evid: 160.
    
    
     * contactsDisplayed - Type: numeric. Desc: deprecated
     *
     * hasContacts - Type: bool. Desc: deprecated
     *
     * msid - Type: guid.
     *
     * number_of_contacts - Type: numeric.
     *
     * pageView - Type: string. Desc: deprecated
     *
     * source - Type: string.
     * @param {exportContactsOpenParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.exportContactsOpen = function (params) {
        return this.bi.log(__assign({ evid: 160 }, params));
    };
    /**
    * @typedef {Object} contactsSubscribersParams
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - null
    * @property {string} pageView - null
    * @property {number} tagcount - null
    **/
    /**
     * Name: contacts -> subscribers. Evid: 108.
    
    
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid.
     *
     * pageView - Type: string.
     *
     * tagcount - Type: numeric.
     * @param {contactsSubscribersParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsSubscribers = function (params) {
        return this.bi.log(__assign({ evid: 108 }, params));
    };
    /**
    * @typedef {Object} contactsFetchContactsSuccessParams
    * @property {number} contactsDisplayed - null
    * @property {string} filterBy - all/label/custom/saved filter
    * @property {boolean} hasContacts - null
    * @property {number} loadingTime - time elapsed from starting fetching contacts till finish
    * @property {GUID} msid - metasite id
    * @property {string} pageView - null
    * @property {boolean} usedSearch - T/F
    **/
    /**
     * Name: contacts ->Fetch Contacts - Success. Evid: 252.
     * Event description: Fetch Contacts - Success.
    
     * contactsDisplayed - Type: numeric.
     *
     * filterBy - Type: string. Desc: all/label/custom/saved filter
     *
     * hasContacts - Type: bool.
     *
     * loadingTime - Type: numeric. Desc: time elapsed from starting fetching contacts till finish
     *
     * msid - Type: guid. Desc: metasite id
     *
     * pageView - Type: string.
     *
     * usedSearch - Type: bool. Desc: T/F
     * @param {contactsFetchContactsSuccessParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsFetchContactsSuccess = function (params) {
        return this.bi.log(__assign({ evid: 252 }, params));
    };
    /**
    * @typedef {Object} contactsClickOnCloseManageContactsTip238Params
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - meta site id
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts -> click on close manage contacts tip. Evid: 238.
     * Event description: click on close manage contacts tip.
    
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: meta site id
     *
     * pageView - Type: string.
     * @param {contactsClickOnCloseManageContactsTip238Params} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsClickOnCloseManageContactsTip238 = function (params) {
        return this.bi.log(__assign({ evid: 238 }, params));
    };
    /**
    * @typedef {Object} importContactsMarkAsSubscribersClickParams
    * @property {GUID} appstreamid - unique identifier of import session
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {string} import_type - 'gmail account' / 'csv file'
    * @property {GUID} msid - msid
    * @property {string} origin - The hosting application
    * @property {string} package_group - package_group
    * @property {string} package_id - package_name
    * @property {string} pageView - null
    * @property {string} selection - yes , no
    **/
    /**
     * Name: import contacts -> Mark as Subscribers -  click. Evid: 220.
     * Event description: Mark as Subscribers -  click.
    
     * appstreamid - Type: guid. Desc: unique identifier of import session
     *
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * import_type - Type: string. Desc: 'gmail account' / 'csv file'
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: The hosting application
     *
     * package_group - Type: string. Desc: package_group
     *
     * package_id - Type: string. Desc: package_name
     *
     * pageView - Type: string.
     *
     * selection - Type: string. Desc: yes , no
     * @param {importContactsMarkAsSubscribersClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.importContactsMarkAsSubscribersClick = function (params) {
        return this.bi.log(__assign({ evid: 220 }, params));
    };
    /**
    * @typedef {Object} contactsAdvancedFiltersClickOnRenameFilterParams
    * @property {number} contactsDisplayed - null
    * @property {string} filterID - filterID
    * @property {string} filterName - filterName
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - metasite id
    * @property {string} pageView - pageView
    **/
    /**
     * Name: contacts ->Advanced Filters - click on rename filter. Evid: 267.
     * Event description: click on rename filter.
    
     * contactsDisplayed - Type: numeric.
     *
     * filterID - Type: string. Desc: filterID
     *
     * filterName - Type: string. Desc: filterName
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: metasite id
     *
     * pageView - Type: string. Desc: pageView
     * @param {contactsAdvancedFiltersClickOnRenameFilterParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsAdvancedFiltersClickOnRenameFilter = function (params) {
        return this.bi.log(__assign({ evid: 267 }, params));
    };
    /**
    * @typedef {Object} contactsClickOnCustomersParams
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - null
    * @property {string} pageView - null
    * @property {number} tagcount - null
    **/
    /**
     * Name: contacts -> click on customers. Evid: 102.
    
    
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid.
     *
     * pageView - Type: string.
     *
     * tagcount - Type: numeric.
     * @param {contactsClickOnCustomersParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsClickOnCustomers = function (params) {
        return this.bi.log(__assign({ evid: 102 }, params));
    };
    /**
    * @typedef {Object} contactsBouncedTagParams
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - msid
    * @property {string} pageView - null
    * @property {number} tagcount - count
    **/
    /**
     * Name: contacts -> bounced tag. Evid: 173.
     * Event description: send each time user click bounced tag.
    
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: msid
     *
     * pageView - Type: string.
     *
     * tagcount - Type: numeric. Desc: count
     * @param {contactsBouncedTagParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsBouncedTag = function (params) {
        return this.bi.log(__assign({ evid: 173 }, params));
    };
    /**
    * @typedef {Object} contactsAdvancedFiltersRenameFilterCancellationParams
    * @property {string} cancelType - 'cancel' / 'dismiss'
    * @property {number} contactsDisplayed - null
    * @property {string} filterID - filterID
    * @property {string} filterName - filterName
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - metasite id
    * @property {string} pageView - pageView
    **/
    /**
     * Name: contacts ->Advanced Filters - rename filter -cancellation. Evid: 269.
     * Event description: rename filter - cancellation.
    
     * cancelType - Type: string. Desc: 'cancel' / 'dismiss'
     *
     * contactsDisplayed - Type: numeric.
     *
     * filterID - Type: string. Desc: filterID
     *
     * filterName - Type: string. Desc: filterName
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: metasite id
     *
     * pageView - Type: string. Desc: pageView
     * @param {contactsAdvancedFiltersRenameFilterCancellationParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsAdvancedFiltersRenameFilterCancellation = function (params) {
        return this.bi.log(__assign({ evid: 269 }, params));
    };
    /**
    * @typedef {Object} contactsAdvancedFiltersCreateFilterChooseConditionFieldParams
    * @property {string} conditionField - condition_field= 'Email'/'First Name'/...
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - metasite id
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts -> Advanced Filters -Create Filter - choose condition field. Evid: 248.
     * Event description: Create Filter - choose condition field.
    
     * conditionField - Type: string. Desc: condition_field= 'Email'/'First Name'/...
     *
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: metasite id
     *
     * pageView - Type: string.
     * @param {contactsAdvancedFiltersCreateFilterChooseConditionFieldParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsAdvancedFiltersCreateFilterChooseConditionField = function (params) {
        return this.bi.log(__assign({ evid: 248 }, params));
    };
    /**
    * @typedef {Object} importContactsGmailDisconnectParams
    * @property {string} account_id - null
    * @property {GUID} appstreamid - null
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - null
    * @property {string} origin - The hosting application
    * @property {string} pageView - null
    **/
    /**
     * Name: import contacts -> gmail disconnect. Evid: 156.
    
    
     * account_id - Type: string.
     *
     * appstreamid - Type: guid.
     *
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid.
     *
     * origin - Type: string. Desc: The hosting application
     *
     * pageView - Type: string.
     * @param {importContactsGmailDisconnectParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.importContactsGmailDisconnect = function (params) {
        return this.bi.log(__assign({ evid: 156 }, params));
    };
    /**
    * @typedef {Object} contactsImportContactsParams
    * @property {GUID} app_id - null
    * @property {GUID} appId - null
    * @property {GUID} appstreamid - null
    * @property {string} clickOrigin - 'manage contacts banner'/ 'manage contacts tip'/'contacts app'
    * @property {number} contactsDisplayed - null
    * @property {string} context - context
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - null
    * @property {string} origin - The hosting application
    * @property {string} package_group - package_group
    * @property {string} package_id - package_name
    * @property {string} pageView - null
    * @property {string} source - null
    **/
    /**
     * Name: contacts -> import contacts. Evid: 150.
    
    
     * app_id - Type: guid.
     *
     * appId - Type: guid.
     *
     * appstreamid - Type: guid.
     *
     * clickOrigin - Type: string. Desc: 'manage contacts banner'/ 'manage contacts tip'/'contacts app'
     *
     * contactsDisplayed - Type: numeric.
     *
     * context - Type: string. Desc: context
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid.
     *
     * origin - Type: string. Desc: The hosting application
     *
     * package_group - Type: string. Desc: package_group
     *
     * package_id - Type: string. Desc: package_name
     *
     * pageView - Type: string.
     *
     * source - Type: string.
     * @param {contactsImportContactsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsImportContacts = function (params) {
        return this.bi.log(__assign({ evid: 150 }, params));
    };
    /**
    * @typedef {Object} contactsContactViewSaveInEditWindowParams
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - null
    * @property {string} origin - what app opened the edit contact modal
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts -> contact view -> save in edit window. Evid: 123.
    
    
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid.
     *
     * origin - Type: string. Desc: what app opened the edit contact modal
     *
     * pageView - Type: string.
     * @param {contactsContactViewSaveInEditWindowParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsContactViewSaveInEditWindow = function (params) {
        return this.bi.log(__assign({ evid: 123 }, params));
    };
    /**
    * @typedef {Object} contactsSiteMembersSettingsIndividualParams
    * @property {number} contactsDisplayed - deprecated
    * @property {boolean} hasContacts - deprecated
    * @property {GUID} msid - msid
    * @property {string} pageView - deprecated
    **/
    /**
     * Name: contacts -> site members settings -> individual. Evid: 116.
    
    
     * contactsDisplayed - Type: numeric. Desc: deprecated
     *
     * hasContacts - Type: bool. Desc: deprecated
     *
     * msid - Type: guid. Desc: msid
     *
     * pageView - Type: string. Desc: deprecated
     * @param {contactsSiteMembersSettingsIndividualParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsSiteMembersSettingsIndividual = function (params) {
        return this.bi.log(__assign({ evid: 116 }, params));
    };
    /**
    * @typedef {Object} contactsRemoveLabelFromContactParams
    * @property {number} contactsDisplayed - deprecated
    * @property {boolean} hasContacts - deprecated
    * @property {GUID} msid - msid
    * @property {string} name - name of label
    * @property {string} pageView - deprecated
    **/
    /**
     * Name: contacts -> remove label from contact. Evid: 174.
     * Event description: user clicks remove on a label in contact card.
    
     * contactsDisplayed - Type: numeric. Desc: deprecated
     *
     * hasContacts - Type: bool. Desc: deprecated
     *
     * msid - Type: guid. Desc: msid
     *
     * name - Type: string. Desc: name of label
     *
     * pageView - Type: string. Desc: deprecated
     * @param {contactsRemoveLabelFromContactParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsRemoveLabelFromContact = function (params) {
        return this.bi.log(__assign({ evid: 174 }, params));
    };
    /**
    * @typedef {Object} contactsConnectedToGoogleSuccessParams
    * @property {string} contact_id - contact identifier
    * @property {number} contactsDisplayed - null
    * @property {string} group - the clicked contacts tab
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - null
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts -> Connected to Google success. Evid: 184.
     * Event description: Connected to Google success.
    
     * contact_id - Type: string. Desc: contact identifier
     *
     * contactsDisplayed - Type: numeric.
     *
     * group - Type: string. Desc: the clicked contacts tab
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid.
     *
     * pageView - Type: string.
     * @param {contactsConnectedToGoogleSuccessParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsConnectedToGoogleSuccess = function (params) {
        return this.bi.log(__assign({ evid: 184 }, params));
    };
    /**
    * @typedef {Object} importContactsImportCompleteParams
    * @property {number} added_contacts - # added contacts
    * @property {GUID} appstreamid - null
    * @property {number} contactsDisplayed - null
    * @property {string} context - context
    * @property {number} elapsed_time - elapsed time measured in ms
    * @property {string} file_type - file type
    * @property {boolean} hasContacts - null
    * @property {GUID} import_id - null
    * @property {string} status - null
    * @property {string} import_type - 'csv','gmail'
    * @property {boolean} is_bulk - type of import
    * @property {GUID} msid - null
    * @property {number} number_of_contacts - null
    * @property {number} number_of_skipped_contacts - skipped contacts
    * @property {string} origin - The hosting application
    * @property {string} package_group - package_group
    * @property {string} package_id - package_name
    * @property {string} pageView - null
    * @property {string} source - null
    * @property {number} updated_contacts - # contacts updated
    **/
    /**
     * Name: import contacts -> import complete. Evid: 155.
    
    
     * added_contacts - Type: numeric. Desc: # added contacts
     *
     * appstreamid - Type: guid.
     *
     * contactsDisplayed - Type: numeric.
     *
     * context - Type: string. Desc: context
     *
     * elapsed_time - Type: numeric. Desc: elapsed time measured in ms
     *
     * file_type - Type: string. Desc: file type
     *
     * hasContacts - Type: bool.
     *
     * import_id - Type: guid.
     *
     * status - Type: string.
     *
     * import_type - Type: string. Desc: 'csv','gmail'
     *
     * is_bulk - Type: bool. Desc: type of import
     *
     * msid - Type: guid.
     *
     * number_of_contacts - Type: numeric.
     *
     * number_of_skipped_contacts - Type: numeric. Desc: skipped contacts
     *
     * origin - Type: string. Desc: The hosting application
     *
     * package_group - Type: string. Desc: package_group
     *
     * package_id - Type: string. Desc: package_name
     *
     * pageView - Type: string.
     *
     * source - Type: string.
     *
     * updated_contacts - Type: numeric. Desc: # contacts updated
     * @param {importContactsImportCompleteParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.importContactsImportComplete = function (params) {
        return this.bi.log(__assign({ evid: 155 }, params));
    };
    /**
    * @typedef {Object} exportContactsFinishExportSuccessParams
    * @property {string} contact_type - chosen/ group
    * @property {number} contactsDisplayed - deprecated
    * @property {string} export_type - export format
    * @property {boolean} hasContacts - deprecated
    * @property {GUID} msid - null
    * @property {string} pageView - deprecated
    * @property {string} source - source
    **/
    /**
     * Name: export contacts -> finish export success. Evid: 166.
     * Event description: finish export success.
    
     * contact_type - Type: string. Desc: chosen/ group
     *
     * contactsDisplayed - Type: numeric. Desc: deprecated
     *
     * export_type - Type: string. Desc: export format
     *
     * hasContacts - Type: bool. Desc: deprecated
     *
     * msid - Type: guid.
     *
     * pageView - Type: string. Desc: deprecated
     *
     * source - Type: string. Desc: source
     * @param {exportContactsFinishExportSuccessParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.exportContactsFinishExportSuccess = function (params) {
        return this.bi.log(__assign({ evid: 166 }, params));
    };
    /**
    * @typedef {Object} tempClientEventParams
    * @property {number} contactsDisplayed - deprecated
    * @property {string} description - event description or name
    * @property {string} field1 - all the event data (string or json)
    * @property {boolean} hasContacts - deprecated
    * @property {GUID} msid - optional
    * @property {string} name - name of dev
    * @property {string} pageView - deprecated
    **/
    /**
     * Name: temp client event. Evid: 99.
     * Event description: this is a general event for temp events.
    
     * contactsDisplayed - Type: numeric. Desc: deprecated
     *
     * description - Type: string. Desc: event description or name
     *
     * field1 - Type: string. Desc: all the event data (string or json)
     *
     * hasContacts - Type: bool. Desc: deprecated
     *
     * msid - Type: guid. Desc: optional
     *
     * name - Type: string. Desc: name of dev
     *
     * pageView - Type: string. Desc: deprecated
     * @param {tempClientEventParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.tempClientEvent = function (params) {
        return this.bi.log(__assign({ evid: 99 }, params));
    };
    /**
    * @typedef {Object} contactsUploadPhotoUploadFailedParams
    * @property {string} contact_id - deprecated
    * @property {GUID} contactId - contact_id
    * @property {number} contactsDisplayed - null
    * @property {string} error_message - deprecated
    * @property {string} errorMessage - error_message
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - meta site id
    * @property {string} pageView - pageView
    **/
    /**
     * Name: contacts - upload photo - upload failed. Evid: 233.
     * Event description: photo -upload failed.
    
     * contact_id - Type: string. Desc: deprecated
     *
     * contactId - Type: guid. Desc: contact_id
     *
     * contactsDisplayed - Type: numeric.
     *
     * error_message - Type: string. Desc: deprecated
     *
     * errorMessage - Type: string. Desc: error_message
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: meta site id
     *
     * pageView - Type: string. Desc: pageView
     * @param {contactsUploadPhotoUploadFailedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsUploadPhotoUploadFailed = function (params) {
        return this.bi.log(__assign({ evid: 233 }, params));
    };
    /**
    * @typedef {Object} contactsCustomFieldsCustomFieldRenameSuccessParams
    * @property {number} contactsDisplayed - null
    * @property {string} fieldName - field original name
    * @property {string} fieldNewName - field new name
    * @property {string} fieldType - field type
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - site id
    * @property {string} origin - edit contact, new contact, manage custom fields...
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts -> custom fields -> Custom Field rename success. Evid: 211.
     * Event description: when user adds/renames a custom field, a window is opened.
    
     * contactsDisplayed - Type: numeric.
     *
     * fieldName - Type: string. Desc: field original name
     *
     * fieldNewName - Type: string. Desc: field new name
     *
     * fieldType - Type: string. Desc: field type
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: site id
     *
     * origin - Type: string. Desc: edit contact, new contact, manage custom fields...
     *
     * pageView - Type: string.
     * @param {contactsCustomFieldsCustomFieldRenameSuccessParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsCustomFieldsCustomFieldRenameSuccess = function (params) {
        return this.bi.log(__assign({ evid: 211 }, params));
    };
    /**
    * @typedef {Object} contactsAttachmentsUploadProgressScreenDisplayedParams
    * @property {string} contactId - contact id
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - meta site id
    * @property {string} name - upload, success
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts -> attachments -> upload progress screen displayed. Evid: 214.
     * Event description: upload progress screen is displayed (upload in progress or success).
    
     * contactId - Type: string. Desc: contact id
     *
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: meta site id
     *
     * name - Type: string. Desc: upload, success
     *
     * pageView - Type: string.
     * @param {contactsAttachmentsUploadProgressScreenDisplayedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsAttachmentsUploadProgressScreenDisplayed = function (params) {
        return this.bi.log(__assign({ evid: 214 }, params));
    };
    /**
    * @typedef {Object} contactsClickOnCtaOnModalParams
    * @property {number} contactsDisplayed - null
    * @property {string} displayName - all contacts, contacted me, customers...
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - site id
    * @property {string} name - action/destination name
    * @property {string} origin - modal name on which the CTA is found
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts -> Click on CTA on modal. Evid: 178.
     * Event description: user clicks button / link.
    
     * contactsDisplayed - Type: numeric.
     *
     * displayName - Type: string. Desc: all contacts, contacted me, customers...
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: site id
     *
     * name - Type: string. Desc: action/destination name
     *
     * origin - Type: string. Desc: modal name on which the CTA is found
     *
     * pageView - Type: string.
     * @param {contactsClickOnCtaOnModalParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsClickOnCtaOnModal = function (params) {
        return this.bi.log(__assign({ evid: 178 }, params));
    };
    /**
    * @typedef {Object} contactsSiteMembersSettingsOkParams
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - null
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts -> site members settings -> OK. Evid: 119.
    
    
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid.
     *
     * pageView - Type: string.
     * @param {contactsSiteMembersSettingsOkParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsSiteMembersSettingsOk = function (params) {
        return this.bi.log(__assign({ evid: 119 }, params));
    };
    /**
    * @typedef {Object} contactsInEngageScrollContactListPageFetchParams
    * @property {string} app_instance_id - instance_id
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} bi_token - bi token -> msid
    * @property {GUID} msid - null
    * @property {string} pageView - null
    **/
    /**
     * Name: Contacts in Engage - scroll contact list (page fetch). Evid: 533.
     * Event description: New page fetched from server when scrolling down the list of contacts in engage native app.
    
     * app_instance_id - Type: string. Desc: instance_id
     *
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * bi_token - Type: guid. Desc: bi token -> msid
     *
     * msid - Type: guid.
     *
     * pageView - Type: string.
     * @param {contactsInEngageScrollContactListPageFetchParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsInEngageScrollContactListPageFetch = function (params) {
        return this.bi.log(__assign({ evid: 533 }, params));
    };
    /**
    * @typedef {Object} importContactsUploadAgainClickParams
    * @property {GUID} appstreamid - unique identifier of import session
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - msid
    * @property {string} origin - The hosting application
    * @property {string} package_group - package_group
    * @property {string} package_id - package_name
    * @property {string} pageView - null
    **/
    /**
     * Name: import contacts -> upload again - click. Evid: 224.
     * Event description: upload again - click.
    
     * appstreamid - Type: guid. Desc: unique identifier of import session
     *
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: The hosting application
     *
     * package_group - Type: string. Desc: package_group
     *
     * package_id - Type: string. Desc: package_name
     *
     * pageView - Type: string.
     * @param {importContactsUploadAgainClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.importContactsUploadAgainClick = function (params) {
        return this.bi.log(__assign({ evid: 224 }, params));
    };
    /**
    * @typedef {Object} contactsPressedOnConnectToGoogleParams
    * @property {string} contact_id - contact identifier
    * @property {number} contactsDisplayed - null
    * @property {string} group - the clicked contacts tab
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - null
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts -> Pressed on connect to google. Evid: 183.
     * Event description: Pressed on connect to google.
    
     * contact_id - Type: string. Desc: contact identifier
     *
     * contactsDisplayed - Type: numeric.
     *
     * group - Type: string. Desc: the clicked contacts tab
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid.
     *
     * pageView - Type: string.
     * @param {contactsPressedOnConnectToGoogleParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsPressedOnConnectToGoogle = function (params) {
        return this.bi.log(__assign({ evid: 183 }, params));
    };
    /**
    * @typedef {Object} contactsAdvancedFiltersEditFilterParams
    * @property {number} contactsDisplayed - null
    * @property {string} filterID - filterID
    * @property {string} filterName - filterName
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - metasite id
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts ->Advanced Filters - edit filter. Evid: 258.
     * Event description: user click on edit filter.
    
     * contactsDisplayed - Type: numeric.
     *
     * filterID - Type: string. Desc: filterID
     *
     * filterName - Type: string. Desc: filterName
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: metasite id
     *
     * pageView - Type: string.
     * @param {contactsAdvancedFiltersEditFilterParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsAdvancedFiltersEditFilter = function (params) {
        return this.bi.log(__assign({ evid: 258 }, params));
    };
    /**
    * @typedef {Object} importContactsStartImportingParams
    * @property {GUID} appstreamid - null
    * @property {number} contactsDisplayed - null
    * @property {string} context - context
    * @property {boolean} hasContacts - null
    * @property {boolean} is_subscriber - null
    * @property {GUID} msid - null
    * @property {string} origin - The hosting application
    * @property {string} package_group - package_group
    * @property {string} package_id - package_name
    * @property {string} pageView - null
    * @property {string} source - null
    **/
    /**
     * Name: import contacts -> start importing. Evid: 154.
    
    
     * appstreamid - Type: guid.
     *
     * contactsDisplayed - Type: numeric.
     *
     * context - Type: string. Desc: context
     *
     * hasContacts - Type: bool.
     *
     * is_subscriber - Type: bool.
     *
     * msid - Type: guid.
     *
     * origin - Type: string. Desc: The hosting application
     *
     * package_group - Type: string. Desc: package_group
     *
     * package_id - Type: string. Desc: package_name
     *
     * pageView - Type: string.
     *
     * source - Type: string.
     * @param {importContactsStartImportingParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.importContactsStartImporting = function (params) {
        return this.bi.log(__assign({ evid: 154 }, params));
    };
    /**
    * @typedef {Object} contactsFullPageOpenFullPageClickParams
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - msid
    * @property {string} origin - where he full page was opened from
    * @property {string} pageView - null
    **/
    /**
     * Name: Contacts - Full Page - open full page click. Evid: 295.
     * Event description: Contacts - Full Page - open full page click.
    
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: where he full page was opened from
     *
     * pageView - Type: string.
     * @param {contactsFullPageOpenFullPageClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsFullPageOpenFullPageClick = function (params) {
        return this.bi.log(__assign({ evid: 295 }, params));
    };
    /**
    * @typedef {Object} contactsWentBackToTheEMailListParams
    * @property {string} contact_id - contact identifier
    * @property {number} contactsDisplayed - null
    * @property {string} group - the clicked contacts tab
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - null
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts -> Went back to the e-mail list. Evid: 187.
     * Event description: Went back to the e-mail list.
    
     * contact_id - Type: string. Desc: contact identifier
     *
     * contactsDisplayed - Type: numeric.
     *
     * group - Type: string. Desc: the clicked contacts tab
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid.
     *
     * pageView - Type: string.
     * @param {contactsWentBackToTheEMailListParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsWentBackToTheEMailList = function (params) {
        return this.bi.log(__assign({ evid: 187 }, params));
    };
    /**
    * @typedef {Object} contactsFullPageMemberInfoParams
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - msid
    * @property {string} pageView - null
    **/
    /**
     * Name: Contacts - Full Page - Member Info. Evid: 289.
     * Event description: Copy of Contacts - Full Page - Member Info.
    
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: msid
     *
     * pageView - Type: string.
     * @param {contactsFullPageMemberInfoParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsFullPageMemberInfo = function (params) {
        return this.bi.log(__assign({ evid: 289 }, params));
    };
    /**
    * @typedef {Object} contactsContactViewRemoveFieldParams
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - null
    * @property {string} pageView - null
    * @property {string} type - type
    **/
    /**
     * Name: contacts -> contact view -> remove field. Evid: 133.
    
    
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid.
     *
     * pageView - Type: string.
     *
     * type - Type: string. Desc: type
     * @param {contactsContactViewRemoveFieldParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsContactViewRemoveField = function (params) {
        return this.bi.log(__assign({ evid: 133 }, params));
    };
    /**
    * @typedef {Object} contactsSilentLoginSuccesfulParams
    * @property {string} contact_id - contact identifier
    * @property {number} contactsDisplayed - null
    * @property {string} group - the clicked contacts tab
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - null
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts -> Silent Login Succesful. Evid: 182.
     * Event description: Silent Login Succesful - each time user clicks conversation tab after he connected google account.
    
     * contact_id - Type: string. Desc: contact identifier
     *
     * contactsDisplayed - Type: numeric.
     *
     * group - Type: string. Desc: the clicked contacts tab
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid.
     *
     * pageView - Type: string.
     * @param {contactsSilentLoginSuccesfulParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsSilentLoginSuccesful = function (params) {
        return this.bi.log(__assign({ evid: 182 }, params));
    };
    /**
    * @typedef {Object} contactsAdvancedFiltersDeleteConditionSubFilterParams
    * @property {number} contactsDisplayed - null
    * @property {string} filterID - filterID
    * @property {string} filterName - filterName
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - metasite id
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts ->Advanced Filters - delete condition (sub filter). Evid: 264.
     * Event description: user click on  delete condition (sub filter) - in Edit mode of custom filter.
    
     * contactsDisplayed - Type: numeric.
     *
     * filterID - Type: string. Desc: filterID
     *
     * filterName - Type: string. Desc: filterName
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: metasite id
     *
     * pageView - Type: string.
     * @param {contactsAdvancedFiltersDeleteConditionSubFilterParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsAdvancedFiltersDeleteConditionSubFilter = function (params) {
        return this.bi.log(__assign({ evid: 264 }, params));
    };
    /**
    * @typedef {Object} contactsFullPageClickOnActivityLogParams
    * @property {string} action - which action was clicked on
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - msid
    * @property {string} pageView - null
    **/
    /**
     * Name: Contacts - Full Page - click on activity log. Evid: 292.
     * Event description: Copy of Contacts - Full Page - Member Info.
    
     * action - Type: string. Desc: which action was clicked on
     *
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: msid
     *
     * pageView - Type: string.
     * @param {contactsFullPageClickOnActivityLogParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsFullPageClickOnActivityLog = function (params) {
        return this.bi.log(__assign({ evid: 292 }, params));
    };
    /**
    * @typedef {Object} importContactsMatchFieldsCreateCustomFieldClickParams
    * @property {GUID} appstreamid - unique identifier of import session
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - msid
    * @property {string} origin - The hosting application
    * @property {string} package_group - package_group
    * @property {string} package_id - package_name
    * @property {string} pageView - null
    **/
    /**
     * Name: import contacts -> Match fields - create custom field - click. Evid: 223.
     * Event description: Match fields - create custom field.
    
     * appstreamid - Type: guid. Desc: unique identifier of import session
     *
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: The hosting application
     *
     * package_group - Type: string. Desc: package_group
     *
     * package_id - Type: string. Desc: package_name
     *
     * pageView - Type: string.
     * @param {importContactsMatchFieldsCreateCustomFieldClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.importContactsMatchFieldsCreateCustomFieldClick = function (params) {
        return this.bi.log(__assign({ evid: 223 }, params));
    };
    /**
    * @typedef {Object} contactsEditContactSubscriberSettingsPopupParams
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - null
    * @property {string} pageView - null
    * @property {string} type - null
    **/
    /**
     * Name: contacts -> edit contact -> subscriber settings popup. Evid: 128.
    
    
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid.
     *
     * pageView - Type: string.
     *
     * type - Type: string.
     * @param {contactsEditContactSubscriberSettingsPopupParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsEditContactSubscriberSettingsPopup = function (params) {
        return this.bi.log(__assign({ evid: 128 }, params));
    };
    /**
    * @typedef {Object} contactsCloseFilterTipInContacts278Params
    * @property {number} contactsDisplayed - contact displayed
    * @property {boolean} hasContacts - bool
    * @property {GUID} msid - meta site id
    * @property {string} pageView - page view
    **/
    /**
     * Name: contacts ->close 'filter tip' under contacts. Evid: 278.
     * Event description: contacts ->close 'filter tip' in contacts banner.
    
     * contactsDisplayed - Type: numeric. Desc: contact displayed
     *
     * hasContacts - Type: bool. Desc: bool
     *
     * msid - Type: guid. Desc: meta site id
     *
     * pageView - Type: string. Desc: page view
     * @param {contactsCloseFilterTipInContacts278Params} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsCloseFilterTipInContacts278 = function (params) {
        return this.bi.log(__assign({ evid: 278 }, params));
    };
    /**
    * @typedef {Object} contactsDisplayCollaborationTipInContactsParams
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - bool
    * @property {boolean} has_contributor - bool
    * @property {GUID} msid - meta site id
    * @property {string} pageView - null
    **/
    /**
     * Name: Contacts ->display 'Collaboration tip' in contacts. Evid: 274.
     * Event description: contacts ->display 'Collaboration tip' in contacts banner.
    
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool. Desc: bool
     *
     * has_contributor - Type: bool. Desc: bool
     *
     * msid - Type: guid. Desc: meta site id
     *
     * pageView - Type: string.
     * @param {contactsDisplayCollaborationTipInContactsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsDisplayCollaborationTipInContacts = function (params) {
        return this.bi.log(__assign({ evid: 274 }, params));
    };
    /**
    * @typedef {Object} contactsClickOnCreateNewContactInContactsBannerParams
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - meta site id
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts ->click on 'Create New Contact' in contacts banner. Evid: 243.
     * Event description: contacts ->click on 'Create New Contact' in contacts banner.
    
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: meta site id
     *
     * pageView - Type: string.
     * @param {contactsClickOnCreateNewContactInContactsBannerParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsClickOnCreateNewContactInContactsBanner = function (params) {
        return this.bi.log(__assign({ evid: 243 }, params));
    };
    /**
    * @typedef {Object} contactsAdvancedFiltersDeletingConfirmationParams
    * @property {number} contactsDisplayed - null
    * @property {string} filterID - filterID
    * @property {string} filterName - filterName
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - metasite id
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts ->Advanced Filters - deleting confirmation. Evid: 261.
     * Event description: deleting confirmation on Delete Filter pop-up.
    
     * contactsDisplayed - Type: numeric.
     *
     * filterID - Type: string. Desc: filterID
     *
     * filterName - Type: string. Desc: filterName
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: metasite id
     *
     * pageView - Type: string.
     * @param {contactsAdvancedFiltersDeletingConfirmationParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsAdvancedFiltersDeletingConfirmation = function (params) {
        return this.bi.log(__assign({ evid: 261 }, params));
    };
    /**
    * @typedef {Object} contactsContactViewAddLabelInEditWindowParams
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - msid
    * @property {string} label - Label name
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts -> contact view -> add label in edit window. Evid: 281.
     * Event description: contacts -> contact view -> add label in edit window.
    
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: msid
     *
     * label - Type: string. Desc: Label name
     *
     * pageView - Type: string.
     * @param {contactsContactViewAddLabelInEditWindowParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsContactViewAddLabelInEditWindow = function (params) {
        return this.bi.log(__assign({ evid: 281 }, params));
    };
    /**
    * @typedef {Object} contactsOpenNewFieldDropdownListParams
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - site id
    * @property {string} origin - on which view the action was done
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts -> open new field dropdown list. Evid: 194.
     * Event description: add new field dropdown list open.
    
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: site id
     *
     * origin - Type: string. Desc: on which view the action was done
     *
     * pageView - Type: string.
     * @param {contactsOpenNewFieldDropdownListParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsOpenNewFieldDropdownList = function (params) {
        return this.bi.log(__assign({ evid: 194 }, params));
    };
    /**
    * @typedef {Object} contactsFullPageViewAllParams
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - msid
    * @property {string} pageView - null
    **/
    /**
     * Name: Contacts - Full Page - View All. Evid: 288.
     * Event description: Contacts - Full Page - View All.
    
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: msid
     *
     * pageView - Type: string.
     * @param {contactsFullPageViewAllParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsFullPageViewAll = function (params) {
        return this.bi.log(__assign({ evid: 288 }, params));
    };
    /**
    * @typedef {Object} contactsDeleteNoteCllickParams
    * @property {GUID} contactId - contact unique id
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - msid
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts -> Delete Note Cllick. Evid: 165.
     * Event description: deleting a note in contact card.
    
     * contactId - Type: guid. Desc: contact unique id
     *
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: msid
     *
     * pageView - Type: string.
     * @param {contactsDeleteNoteCllickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsDeleteNoteCllick = function (params) {
        return this.bi.log(__assign({ evid: 165 }, params));
    };
    /**
    * @typedef {Object} contactsFullPageMoreActionsChooseParams
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - msid
    * @property {string} option - null
    * @property {string} pageView - null
    **/
    /**
     * Name: Contacts - Full Page - more actions - Choose. Evid: 284.
     * Event description: Contacts - Full Page - more actions - Choose.
    
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: msid
     *
     * option - Type: string.
     *
     * pageView - Type: string.
     * @param {contactsFullPageMoreActionsChooseParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsFullPageMoreActionsChoose = function (params) {
        return this.bi.log(__assign({ evid: 284 }, params));
    };
    /**
    * @typedef {Object} exportContactsChooseFormatParams
    * @property {number} contactsDisplayed - deprecated
    * @property {boolean} hasContacts - deprecated
    * @property {GUID} msid - null
    * @property {string} pageView - deprecated
    * @property {string} source - null
    * @property {string} type - type of format
    **/
    /**
     * Name: export contacts -> choose format. Evid: 161.
    
    
     * contactsDisplayed - Type: numeric. Desc: deprecated
     *
     * hasContacts - Type: bool. Desc: deprecated
     *
     * msid - Type: guid.
     *
     * pageView - Type: string. Desc: deprecated
     *
     * source - Type: string.
     *
     * type - Type: string. Desc: type of format
     * @param {exportContactsChooseFormatParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.exportContactsChooseFormat = function (params) {
        return this.bi.log(__assign({ evid: 161 }, params));
    };
    /**
    * @typedef {Object} contactsDisplayFilterTipInContactsParams
    * @property {number} contactsDisplayed - contact displayed
    * @property {boolean} hasContacts - bool
    * @property {GUID} msid - meta site id
    * @property {string} pageView - page view
    **/
    /**
     * Name: contacts ->display 'filter tip' in contacts. Evid: 271.
     * Event description: contacts ->display 'filter tip' in contacts banner.
    
     * contactsDisplayed - Type: numeric. Desc: contact displayed
     *
     * hasContacts - Type: bool. Desc: bool
     *
     * msid - Type: guid. Desc: meta site id
     *
     * pageView - Type: string. Desc: page view
     * @param {contactsDisplayFilterTipInContactsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsDisplayFilterTipInContacts = function (params) {
        return this.bi.log(__assign({ evid: 271 }, params));
    };
    /**
    * @typedef {Object} contactsBackFromFiltersParams
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - null
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts -> back from filters. Evid: 130.
    
    
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid.
     *
     * pageView - Type: string.
     * @param {contactsBackFromFiltersParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsBackFromFilters = function (params) {
        return this.bi.log(__assign({ evid: 130 }, params));
    };
    /**
    * @typedef {Object} contactsOpenManageCustomFieldsDialogParams
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - metasite id
    * @property {string} origin - contacts-list, contact-card-actions, contacts-card-labels
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts -> open manage custom fields dialog. Evid: 197.
     * Event description: user clicks manage custom fields and the dialog is opened.
    
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: metasite id
     *
     * origin - Type: string. Desc: contacts-list, contact-card-actions, contacts-card-labels
     *
     * pageView - Type: string.
     * @param {contactsOpenManageCustomFieldsDialogParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsOpenManageCustomFieldsDialog = function (params) {
        return this.bi.log(__assign({ evid: 197 }, params));
    };
    /**
    * @typedef {Object} contactsClickOnGetStartedInContactsTipParams
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - meta site id
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts ->click on 'Get Started' in contacts tip. Evid: 244.
     * Event description: contacts ->click on 'Get Started' in contacts tip.
    
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: meta site id
     *
     * pageView - Type: string.
     * @param {contactsClickOnGetStartedInContactsTipParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsClickOnGetStartedInContactsTip = function (params) {
        return this.bi.log(__assign({ evid: 244 }, params));
    };
    /**
    * @typedef {Object} contactsAttachmentsClickAddAttachmentParams
    * @property {string} contactId - contact id
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - meta site id
    * @property {string} origin - “contact panel”,”full page”
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts -> attachments -> click add attachment. Evid: 213.
     * Event description: user clicks on add attachment in a contact card.
    
     * contactId - Type: string. Desc: contact id
     *
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: meta site id
     *
     * origin - Type: string. Desc: “contact panel”,”full page”
     *
     * pageView - Type: string.
     * @param {contactsAttachmentsClickAddAttachmentParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsAttachmentsClickAddAttachment = function (params) {
        return this.bi.log(__assign({ evid: 213 }, params));
    };
    /**
    * @typedef {Object} contactsApproveContactParams
    * @property {number} contactsDisplayed - number of contacts displayed to the user
    * @property {number} count_of_approved - count of selected contacts for approval
    * @property {boolean} hasContacts - true if user has contacts
    * @property {GUID} msid - null
    * @property {string} label - deprecated
    * @property {string} origin - the view on which the action done
    * @property {string} page_display - in old contacts app: full-list/ slim-list. in new contacts: null
    * @property {string} pageView - old contacts app: all/ label. new contacts: null
    * @property {string} place - the actual button that was clicked on the page
    * @property {string} type - deprecated
    **/
    /**
     * Name: contacts -> approve contact. Evid: 134.
     * Event description: when a contact or group of contacts are approved by the user.
    
     * contactsDisplayed - Type: numeric. Desc: number of contacts displayed to the user
     *
     * count_of_approved - Type: numeric. Desc: count of selected contacts for approval
     *
     * hasContacts - Type: bool. Desc: true if user has contacts
     *
     * msid - Type: guid.
     *
     * label - Type: string. Desc: deprecated
     *
     * origin - Type: string. Desc: the view on which the action done
     *
     * page_display - Type: string. Desc: in old contacts app: full-list/ slim-list. in new contacts: null
     *
     * pageView - Type: string. Desc: old contacts app: all/ label. new contacts: null
     *
     * place - Type: string. Desc: the actual button that was clicked on the page
     *
     * type - Type: string. Desc: deprecated
     * @param {contactsApproveContactParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsApproveContact = function (params) {
        return this.bi.log(__assign({ evid: 134 }, params));
    };
    /**
    * @typedef {Object} contactsNewLabelParams
    * @property {number} contactsDisplayed - deprecated
    * @property {boolean} hasContacts - deprecated
    * @property {GUID} msid - metasite id
    * @property {string} origin - contacts-list, contact-card, manage-labels
    * @property {string} page_display - deprecated
    * @property {string} pageView - deprecated
    **/
    /**
     * Name: contacts -> new label. Evid: 135.
     * Event description: user clicks on create new label.
    
     * contactsDisplayed - Type: numeric. Desc: deprecated
     *
     * hasContacts - Type: bool. Desc: deprecated
     *
     * msid - Type: guid. Desc: metasite id
     *
     * origin - Type: string. Desc: contacts-list, contact-card, manage-labels
     *
     * page_display - Type: string. Desc: deprecated
     *
     * pageView - Type: string. Desc: deprecated
     * @param {contactsNewLabelParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsNewLabel = function (params) {
        return this.bi.log(__assign({ evid: 135 }, params));
    };
    /**
    * @typedef {Object} importContactsBrowseDragAFileParams
    * @property {GUID} appstreamid - unique identifier of import session
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - msid
    * @property {string} origin - The hosting application
    * @property {string} package_group - package_group
    * @property {string} package_id - package_name
    * @property {string} pageView - null
    * @property {string} uploadType - 'browse'/'drag'
    **/
    /**
     * Name: import contacts -> Browse/ Drag a file. Evid: 219.
     * Event description: user Browse/ Drag a file.
    
     * appstreamid - Type: guid. Desc: unique identifier of import session
     *
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: The hosting application
     *
     * package_group - Type: string. Desc: package_group
     *
     * package_id - Type: string. Desc: package_name
     *
     * pageView - Type: string.
     *
     * uploadType - Type: string. Desc: 'browse'/'drag'
     * @param {importContactsBrowseDragAFileParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.importContactsBrowseDragAFile = function (params) {
        return this.bi.log(__assign({ evid: 219 }, params));
    };
    /**
    * @typedef {Object} contactsNoteActionEndParams
    * @property {string} action - add_note/save/delete
    * @property {string} category - note category
    * @property {string} contact_id - contact_id
    * @property {number} contactsDisplayed - deprecated
    * @property {boolean} hasContacts - deprecated
    * @property {GUID} ldSessionID - deprecated
    * @property {GUID} msid - msid
    * @property {number} num_of_notes - number of note for contact
    * @property {string} origin - null
    * @property {string} pageView - deprecated
    **/
    /**
     * Name: contacts -> note action end. Evid: 196.
     * Event description: user finalize action.
    
     * action - Type: string. Desc: add_note/save/delete
     *
     * category - Type: string. Desc: note category
     *
     * contact_id - Type: string. Desc: contact_id
     *
     * contactsDisplayed - Type: numeric. Desc: deprecated
     *
     * hasContacts - Type: bool. Desc: deprecated
     *
     * ldSessionID - Type: guid. Desc: deprecated
     *
     * msid - Type: guid. Desc: msid
     *
     * num_of_notes - Type: numeric. Desc: number of note for contact
     *
     * origin - Type: string.
     *
     * pageView - Type: string. Desc: deprecated
     * @param {contactsNoteActionEndParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsNoteActionEnd = function (params) {
        return this.bi.log(__assign({ evid: 196 }, params));
    };
    /**
    * @typedef {Object} contactsClickOnBatchOperationParams
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - null
    * @property {string} origin - null
    * @property {string} page_display - null
    * @property {string} pageView - null
    * @property {string} type - null
    **/
    /**
     * Name: contacts -> click on batch operation. Evid: 140.
    
    
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid.
     *
     * origin - Type: string.
     *
     * page_display - Type: string.
     *
     * pageView - Type: string.
     *
     * type - Type: string.
     * @param {contactsClickOnBatchOperationParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsClickOnBatchOperation = function (params) {
        return this.bi.log(__assign({ evid: 140 }, params));
    };
    /**
    * @typedef {Object} contactsEditContactSaveAndCreateAnotherParams
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - msid
    * @property {string} pageView - null
    **/
    /**
     * Name: Contacts - Edit Contact - Save and Create Another. Evid: 293.
     * Event description: Copy of Contacts - Full Page - Member Info.
    
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: msid
     *
     * pageView - Type: string.
     * @param {contactsEditContactSaveAndCreateAnotherParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsEditContactSaveAndCreateAnother = function (params) {
        return this.bi.log(__assign({ evid: 293 }, params));
    };
    /**
    * @typedef {Object} finishLoadingContactsAppParams
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - null
    * @property {string} pageView - null
    * @property {string} prev_view - null
    * @property {string} view - null
    **/
    /**
     * Name: finish loading contacts app. Evid: 302.
    
    
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid.
     *
     * pageView - Type: string.
     *
     * prev_view - Type: string.
     *
     * view - Type: string.
     * @param {finishLoadingContactsAppParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.finishLoadingContactsApp = function (params) {
        return this.bi.log(__assign({ evid: 302 }, params));
    };
    /**
    * @typedef {Object} importContactsFatalErrorParams
    * @property {GUID} appstreamid - unique identifier of import session
    * @property {number} contactsDisplayed - contactsDisplayed
    * @property {string} errorReason - errorReason
    * @property {boolean} hasContacts - hasContacts
    * @property {GUID} msid - msid
    * @property {string} origin - The hosting application
    * @property {string} package_group - package_group
    * @property {string} package_id - package_name
    * @property {string} pageView - pageView
    * @property {string} phase_name - 'upload' / 'match' / 'label'
    **/
    /**
     * Name: import contacts -> Fatal Error. Evid: 230.
     * Event description: import contacts -> Fatal Error.
    
     * appstreamid - Type: guid. Desc: unique identifier of import session
     *
     * contactsDisplayed - Type: numeric. Desc: contactsDisplayed
     *
     * errorReason - Type: string. Desc: errorReason
     *
     * hasContacts - Type: bool. Desc: hasContacts
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: The hosting application
     *
     * package_group - Type: string. Desc: package_group
     *
     * package_id - Type: string. Desc: package_name
     *
     * pageView - Type: string. Desc: pageView
     *
     * phase_name - Type: string. Desc: 'upload' / 'match' / 'label'
     * @param {importContactsFatalErrorParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.importContactsFatalError = function (params) {
        return this.bi.log(__assign({ evid: 230 }, params));
    };
    /**
    * @typedef {Object} contactsManageContactsBannerPresentedParams
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - meta site id
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts -> manage contacts banner presented. Evid: 236.
     * Event description: contacts -> manage contacts banner presented.
    
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: meta site id
     *
     * pageView - Type: string.
     * @param {contactsManageContactsBannerPresentedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsManageContactsBannerPresented = function (params) {
        return this.bi.log(__assign({ evid: 236 }, params));
    };
    /**
    * @typedef {Object} contactsViewContactCardParams
    * @property {string} contact_id - contact id
    * @property {number} contactsDisplayed - deprecated
    * @property {string} group - deprecated
    * @property {boolean} hasContacts - deprecated
    * @property {GUID} msid - metasite id
    * @property {string} name - deprecated
    * @property {string} page_display - deprecated
    * @property {string} pageView - deprecated
    * @property {string} platform - deprecated
    * @property {string} referral - where the contact card was clicked
    **/
    /**
     * Name: contacts -> view contact card. Evid: 147.
     * Event description: web: click on a contact's name ; mobile: view contact.
    
     * contact_id - Type: string. Desc: contact id
     *
     * contactsDisplayed - Type: numeric. Desc: deprecated
     *
     * group - Type: string. Desc: deprecated
     *
     * hasContacts - Type: bool. Desc: deprecated
     *
     * msid - Type: guid. Desc: metasite id
     *
     * name - Type: string. Desc: deprecated
     *
     * page_display - Type: string. Desc: deprecated
     *
     * pageView - Type: string. Desc: deprecated
     *
     * platform - Type: string. Desc: deprecated
     *
     * referral - Type: string. Desc: where the contact card was clicked
     * @param {contactsViewContactCardParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsViewContactCard = function (params) {
        return this.bi.log(__assign({ evid: 147 }, params));
    };
    /**
    * @typedef {Object} contactsAdvancedFiltersDeletingCancellationParams
    * @property {string} cancelType - ‘cancel’/’dismiss’
    * @property {number} contactsDisplayed - null
    * @property {string} filterID - filterID
    * @property {string} filterName - filterName
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - metasite id
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts ->Advanced Filters - deleting cancellation. Evid: 262.
     * Event description: deleting cancellation on Save/Update pop-up.
    
     * cancelType - Type: string. Desc: ‘cancel’/’dismiss’
     *
     * contactsDisplayed - Type: numeric.
     *
     * filterID - Type: string. Desc: filterID
     *
     * filterName - Type: string. Desc: filterName
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: metasite id
     *
     * pageView - Type: string.
     * @param {contactsAdvancedFiltersDeletingCancellationParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsAdvancedFiltersDeletingCancellation = function (params) {
        return this.bi.log(__assign({ evid: 262 }, params));
    };
    /**
    * @typedef {Object} contactsAdvancedFiltersCreateFilterChooseConditionOperatorParams
    * @property {string} conditionOperator - 'contains'/'ends with'....
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - metasite id
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts ->Advanced Filters - Create Filter - choose condition operator. Evid: 249.
     * Event description: Create Filter - choose condition operator.
    
     * conditionOperator - Type: string. Desc: 'contains'/'ends with'....
     *
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: metasite id
     *
     * pageView - Type: string.
     * @param {contactsAdvancedFiltersCreateFilterChooseConditionOperatorParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsAdvancedFiltersCreateFilterChooseConditionOperator = function (params) {
        return this.bi.log(__assign({ evid: 249 }, params));
    };
    /**
    * @typedef {Object} contactsClickedOnAnEMailParams
    * @property {boolean} aboveTheFold - if the email above the fold
    * @property {string} contact_id - contact identifier
    * @property {number} contactsDisplayed - null
    * @property {string} emailValue - email value
    * @property {string} group - the clicked contacts tab
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - null
    * @property {string} pageView - null
    * @property {boolean} unreadEmail - was the email unread or not
    **/
    /**
     * Name: contacts -> Clicked on an e-mail. Evid: 186.
     * Event description: Clicked on an e-mail.
    
     * aboveTheFold - Type: bool. Desc: if the email above the fold
     *
     * contact_id - Type: string. Desc: contact identifier
     *
     * contactsDisplayed - Type: numeric.
     *
     * emailValue - Type: string. Desc: email value
     *
     * group - Type: string. Desc: the clicked contacts tab
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid.
     *
     * pageView - Type: string.
     *
     * unreadEmail - Type: bool. Desc: was the email unread or not
     * @param {contactsClickedOnAnEMailParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsClickedOnAnEMail = function (params) {
        return this.bi.log(__assign({ evid: 186 }, params));
    };
    /**
    * @typedef {Object} importContactsCancelImportParams
    * @property {GUID} appstreamid - null
    * @property {number} contactsDisplayed - null
    * @property {string} context - context
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - null
    * @property {string} origin - The hosting application
    * @property {string} package_group - package_group
    * @property {string} package_id - package_name
    * @property {string} pageView - null
    * @property {string} source - null
    **/
    /**
     * Name: import contacts -> click on 'got it' after import completion - old import. Evid: 153.
    
    
     * appstreamid - Type: guid.
     *
     * contactsDisplayed - Type: numeric.
     *
     * context - Type: string. Desc: context
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid.
     *
     * origin - Type: string. Desc: The hosting application
     *
     * package_group - Type: string. Desc: package_group
     *
     * package_id - Type: string. Desc: package_name
     *
     * pageView - Type: string.
     *
     * source - Type: string.
     * @param {importContactsCancelImportParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.importContactsCancelImport = function (params) {
        return this.bi.log(__assign({ evid: 153 }, params));
    };
    /**
    * @typedef {Object} contactsModalShownClosedParams
    * @property {string} action - shown / closed
    * @property {number} contactsDisplayed - null
    * @property {string} displayName - all contacts, contacted me, customers...
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - site id
    * @property {string} name - modal name
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts -> Modal shown/closed. Evid: 172.
     * Event description: action of Modal (shown / closed).
    
     * action - Type: string. Desc: shown / closed
     *
     * contactsDisplayed - Type: numeric.
     *
     * displayName - Type: string. Desc: all contacts, contacted me, customers...
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: site id
     *
     * name - Type: string. Desc: modal name
     *
     * pageView - Type: string.
     * @param {contactsModalShownClosedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsModalShownClosed = function (params) {
        return this.bi.log(__assign({ evid: 172 }, params));
    };
    /**
    * @typedef {Object} importContactsClickUploadParams
    * @property {GUID} appstreamid - unique identifier of import session
    * @property {number} contactsDisplayed - null
    * @property {string} context - context
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - null
    * @property {string} origin - The hosting application
    * @property {string} package_group - package_group
    * @property {string} package_id - package_name
    * @property {string} pageView - null
    **/
    /**
     * Name: import contacts -> click upload. Evid: 201.
     * Event description: click upload in order to upload file.
    
     * appstreamid - Type: guid. Desc: unique identifier of import session
     *
     * contactsDisplayed - Type: numeric.
     *
     * context - Type: string. Desc: context
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid.
     *
     * origin - Type: string. Desc: The hosting application
     *
     * package_group - Type: string. Desc: package_group
     *
     * package_id - Type: string. Desc: package_name
     *
     * pageView - Type: string.
     * @param {importContactsClickUploadParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.importContactsClickUpload = function (params) {
        return this.bi.log(__assign({ evid: 201 }, params));
    };
    /**
    * @typedef {Object} contactsCustomLabelParams
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - null
    * @property {string} name - null
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts -> custom label. Evid: 109.
    
    
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid.
     *
     * name - Type: string.
     *
     * pageView - Type: string.
     * @param {contactsCustomLabelParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsCustomLabel = function (params) {
        return this.bi.log(__assign({ evid: 109 }, params));
    };
    /**
    * @typedef {Object} contactsCloseCollaborationTipInContactsParams
    * @property {string} closing_method - 'dismiss','got it'
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - bool
    * @property {boolean} has_contributor - bool
    * @property {GUID} msid - meta site id
    * @property {string} pageView - null
    **/
    /**
     * Name: Contacts ->close 'Collaboration tip' in contacts. Evid: 275.
     * Event description: contacts ->closed 'Collaboration tip' in contacts banner.
    
     * closing_method - Type: string. Desc: 'dismiss','got it'
     *
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool. Desc: bool
     *
     * has_contributor - Type: bool. Desc: bool
     *
     * msid - Type: guid. Desc: meta site id
     *
     * pageView - Type: string.
     * @param {contactsCloseCollaborationTipInContactsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsCloseCollaborationTipInContacts = function (params) {
        return this.bi.log(__assign({ evid: 275 }, params));
    };
    /**
    * @typedef {Object} contactsContactViewCloseEditWindowParams
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - null
    * @property {string} origin - what app opened the edit contact modal
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts -> contact view -> close edit window. Evid: 122.
    
    
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid.
     *
     * origin - Type: string. Desc: what app opened the edit contact modal
     *
     * pageView - Type: string.
     * @param {contactsContactViewCloseEditWindowParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsContactViewCloseEditWindow = function (params) {
        return this.bi.log(__assign({ evid: 122 }, params));
    };
    /**
    * @typedef {Object} contactsContactViewEditParams
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - null
    * @property {string} option - 'header','body'
    * @property {string} origin - what app opened the edit contact modal
    * @property {string} pageView - null
    * @property {string} platform - native / web (null=web)
    **/
    /**
     * Name: contacts -> contact view -> edit. Evid: 121.
    
    
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid.
     *
     * option - Type: string. Desc: 'header','body'
     *
     * origin - Type: string. Desc: what app opened the edit contact modal
     *
     * pageView - Type: string.
     *
     * platform - Type: string. Desc: native / web (null=web)
     * @param {contactsContactViewEditParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsContactViewEdit = function (params) {
        return this.bi.log(__assign({ evid: 121 }, params));
    };
    /**
    * @typedef {Object} contactsFullPageChangeTabParams
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - msid
    * @property {string} pageView - null
    * @property {string} tabFrom - name of the priveous tab
    * @property {string} tabTo - name of the current tab
    **/
    /**
     * Name: Contacts - Full Page - change tab. Evid: 291.
     * Event description: Contacts - Add Label click.
    
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: msid
     *
     * pageView - Type: string.
     *
     * tabFrom - Type: string. Desc: name of the priveous tab
     *
     * tabTo - Type: string. Desc: name of the current tab
     * @param {contactsFullPageChangeTabParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsFullPageChangeTab = function (params) {
        return this.bi.log(__assign({ evid: 291 }, params));
    };
    /**
    * @typedef {Object} contactsFilterContactsBySavedFilterParams
    * @property {number} contactsDisplayed - number of contacts displayed
    * @property {boolean} hasContacts - if has contacts
    * @property {GUID} msid - metasite id
    * @property {string} name - saved filer name
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts -> filter contacts by saved filter. Evid: 276.
     * Event description: user filtered the displayed contacts by choosing a saved filter.
    
     * contactsDisplayed - Type: numeric. Desc: number of contacts displayed
     *
     * hasContacts - Type: bool. Desc: if has contacts
     *
     * msid - Type: guid. Desc: metasite id
     *
     * name - Type: string. Desc: saved filer name
     *
     * pageView - Type: string.
     * @param {contactsFilterContactsBySavedFilterParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsFilterContactsBySavedFilter = function (params) {
        return this.bi.log(__assign({ evid: 276 }, params));
    };
    /**
    * @typedef {Object} contactsAddNewContactClickParams
    * @property {string} app_def_id - deprecated
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - msid
    * @property {string} origin - origin app id
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts -> add new contact - click. Evid: 205.
     * Event description: add new contact - click.
    
     * app_def_id - Type: string. Desc: deprecated
     *
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: origin app id
     *
     * pageView - Type: string.
     * @param {contactsAddNewContactClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsAddNewContactClick = function (params) {
        return this.bi.log(__assign({ evid: 205 }, params));
    };
    /**
    * @typedef {Object} contactsAppLoadedParams
    * @property {string} appId - null
    * @property {string} contactId - null
    * @property {number} contactsDisplayed - null
    * @property {string} filter - null
    * @property {boolean} hasContacts - null
    * @property {GUID} metasiteid - null
    * @property {GUID} msid - null
    * @property {string} pageView - null
    * @property {string} search - null
    * @property {string} sort - null
    * @property {string} tag - null
    **/
    /**
     * Name: contacts -> app loaded. Evid: 141.
    
    
     * appId - Type: string.
     *
     * contactId - Type: string.
     *
     * contactsDisplayed - Type: numeric.
     *
     * filter - Type: string.
     *
     * hasContacts - Type: bool.
     *
     * metasiteid - Type: guid.
     *
     * msid - Type: guid.
     *
     * pageView - Type: string.
     *
     * search - Type: string.
     *
     * sort - Type: string.
     *
     * tag - Type: string.
     * @param {contactsAppLoadedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsAppLoaded = function (params) {
        return this.bi.log(__assign({ evid: 141 }, params));
    };
    /**
    * @typedef {Object} contactsAdvancedFiltersClickOnCreateNewFilterParams
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - metasite id
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts -> Advanced Filters - Click on ‘Create New Filter’. Evid: 247.
     * Event description: Click on ‘Create New Filter’.
    
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: metasite id
     *
     * pageView - Type: string.
     * @param {contactsAdvancedFiltersClickOnCreateNewFilterParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsAdvancedFiltersClickOnCreateNewFilter = function (params) {
        return this.bi.log(__assign({ evid: 247 }, params));
    };
    /**
    * @typedef {Object} contactsContactPanelInnerTabsClickParams
    * @property {string} contactId - contact id
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - meta site id
    * @property {string} pageView - crm tab name
    * @property {string} tab_name - deprecated
    * @property {string} tabName - 'info' , 'tasks & notes' , 'inbox'
    **/
    /**
     * Name: contacts -> contact panel -> inner tabs - click. Evid: 231.
     * Event description: user clicks on one of the inner tabs in contact panel - 'info' , 'tasks & notes' , 'inbox'.
    
     * contactId - Type: string. Desc: contact id
     *
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: meta site id
     *
     * pageView - Type: string. Desc: crm tab name
     *
     * tab_name - Type: string. Desc: deprecated
     *
     * tabName - Type: string. Desc: 'info' , 'tasks & notes' , 'inbox'
     * @param {contactsContactPanelInnerTabsClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsContactPanelInnerTabsClick = function (params) {
        return this.bi.log(__assign({ evid: 231 }, params));
    };
    /**
    * @typedef {Object} contactsAdvancedFiltersClickOnSaveUpdateFilterParams
    * @property {string} action - 'save'/'update'
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - metasite id
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts ->Advanced Filters - Click on Save/Update filter. Evid: 254.
     * Event description: Advanced Filters - Click on Save/Update filter.
    
     * action - Type: string. Desc: 'save'/'update'
     *
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: metasite id
     *
     * pageView - Type: string.
     * @param {contactsAdvancedFiltersClickOnSaveUpdateFilterParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsAdvancedFiltersClickOnSaveUpdateFilter = function (params) {
        return this.bi.log(__assign({ evid: 254 }, params));
    };
    /**
    * @typedef {Object} importContactsStepLoadedParams
    * @property {GUID} appstreamid - unique identifier of import session
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {string} importType - 'csv' / 'gmail'
    * @property {GUID} msid - msid
    * @property {string} origin - The hosting application
    * @property {string} pageName - 'Prepare'/'Upload'/'Match'/'Label'  or 'Subscribers'/'Label' or 'Label all'
    * @property {string} pageView - null
    **/
    /**
     * Name: import contacts -> step loaded. Evid: 235.
     * Event description: step loaded.
    
     * appstreamid - Type: guid. Desc: unique identifier of import session
     *
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * importType - Type: string. Desc: 'csv' / 'gmail'
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: The hosting application
     *
     * pageName - Type: string. Desc: 'Prepare'/'Upload'/'Match'/'Label'  or 'Subscribers'/'Label' or 'Label all'
     *
     * pageView - Type: string.
     * @param {importContactsStepLoadedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.importContactsStepLoaded = function (params) {
        return this.bi.log(__assign({ evid: 235 }, params));
    };
    /**
    * @typedef {Object} contactsSiteMembersAllApprovedParams
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - null
    * @property {string} pageView - null
    * @property {number} tagcount - null
    **/
    /**
     * Name: contacts -> site members -> all approved. Evid: 105.
    
    
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid.
     *
     * pageView - Type: string.
     *
     * tagcount - Type: numeric.
     * @param {contactsSiteMembersAllApprovedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsSiteMembersAllApproved = function (params) {
        return this.bi.log(__assign({ evid: 105 }, params));
    };
    /**
    * @typedef {Object} contactsAttachmentsClickOnAttachmentActionParams
    * @property {string} contactId - contact id
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - meta site id
    * @property {string} name - show all, show less, delete,preview,download
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts -> attachments -> click on attachment action. Evid: 217.
     * Event description: user clicks on attachment action (show all, show less, delete, preview, download).
    
     * contactId - Type: string. Desc: contact id
     *
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: meta site id
     *
     * name - Type: string. Desc: show all, show less, delete,preview,download
     *
     * pageView - Type: string.
     * @param {contactsAttachmentsClickOnAttachmentActionParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsAttachmentsClickOnAttachmentAction = function (params) {
        return this.bi.log(__assign({ evid: 217 }, params));
    };
    /**
    * @typedef {Object} contactsClickReplyParams
    * @property {string} contact_id - contact identifier
    * @property {number} contactsDisplayed - null
    * @property {string} group - the clicked contacts tab
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - null
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts -> click Reply. Evid: 188.
     * Event description: Reply.
    
     * contact_id - Type: string. Desc: contact identifier
     *
     * contactsDisplayed - Type: numeric.
     *
     * group - Type: string. Desc: the clicked contacts tab
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid.
     *
     * pageView - Type: string.
     * @param {contactsClickReplyParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsClickReply = function (params) {
        return this.bi.log(__assign({ evid: 188 }, params));
    };
    /**
    * @typedef {Object} contactsContactViewChooseAssigneeInEditWindowParams
    * @property {GUID} assignee - Assignee guid of user name
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - msid
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts -> contact view -> choose assignee in edit window. Evid: 282.
     * Event description: contacts -> contact view -> choose assignee in edit window.
    
     * assignee - Type: guid. Desc: Assignee guid of user name
     *
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: msid
     *
     * pageView - Type: string.
     * @param {contactsContactViewChooseAssigneeInEditWindowParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsContactViewChooseAssigneeInEditWindow = function (params) {
        return this.bi.log(__assign({ evid: 282 }, params));
    };
    /**
    * @typedef {Object} contactsThreadListResultsParams
    * @property {string} contact_id - contact_id
    * @property {number} contactsDisplayed - null
    * @property {number} emails_present - total number presented
    * @property {number} emails_unread - emails_unread
    * @property {string} group - group chosen
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - null
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts -> thread list results. Evid: 192.
     * Event description: total number presented / number of unread.
    
     * contact_id - Type: string. Desc: contact_id
     *
     * contactsDisplayed - Type: numeric.
     *
     * emails_present - Type: numeric. Desc: total number presented
     *
     * emails_unread - Type: numeric. Desc: emails_unread
     *
     * group - Type: string. Desc: group chosen
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid.
     *
     * pageView - Type: string.
     * @param {contactsThreadListResultsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsThreadListResults = function (params) {
        return this.bi.log(__assign({ evid: 192 }, params));
    };
    /**
    * @typedef {Object} contactsMoreActionClickParams
    * @property {number} contactsDisplayed - number of contacts displayed
    * @property {boolean} hasContacts - deprecated
    * @property {GUID} msid - metasite id
    * @property {string} name - deprecated
    * @property {string} origin - deprecated
    * @property {string} page_display - deprecated
    * @property {string} pageView - deprecated
    **/
    /**
     * Name: contacts -> more action click. Evid: 142.
    
    
     * contactsDisplayed - Type: numeric. Desc: number of contacts displayed
     *
     * hasContacts - Type: bool. Desc: deprecated
     *
     * msid - Type: guid. Desc: metasite id
     *
     * name - Type: string. Desc: deprecated
     *
     * origin - Type: string. Desc: deprecated
     *
     * page_display - Type: string. Desc: deprecated
     *
     * pageView - Type: string. Desc: deprecated
     * @param {contactsMoreActionClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsMoreActionClick = function (params) {
        return this.bi.log(__assign({ evid: 142 }, params));
    };
    /**
    * @typedef {Object} contactsSiteMembersSettingsParams
    * @property {number} contactsDisplayed - deprecated
    * @property {boolean} hasContacts - deprecated
    * @property {GUID} msid - msid
    * @property {string} pageView - deprecated
    **/
    /**
     * Name: contacts -> site members settings. Evid: 115.
     * Event description: site members settings is opened.
    
     * contactsDisplayed - Type: numeric. Desc: deprecated
     *
     * hasContacts - Type: bool. Desc: deprecated
     *
     * msid - Type: guid. Desc: msid
     *
     * pageView - Type: string. Desc: deprecated
     * @param {contactsSiteMembersSettingsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsSiteMembersSettings = function (params) {
        return this.bi.log(__assign({ evid: 115 }, params));
    };
    /**
    * @typedef {Object} contactsSiteMembersBlockedParams
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - null
    * @property {string} pageView - null
    * @property {number} tagcount - null
    **/
    /**
     * Name: contacts -> site members -> blocked. Evid: 104.
    
    
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid.
     *
     * pageView - Type: string.
     *
     * tagcount - Type: numeric.
     * @param {contactsSiteMembersBlockedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsSiteMembersBlocked = function (params) {
        return this.bi.log(__assign({ evid: 104 }, params));
    };
    /**
    * @typedef {Object} contactsAllContactsParams
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - null
    * @property {string} pageView - null
    * @property {number} tagcount - null
    * @property {number} tagCount - number of tags
    **/
    /**
     * Name: contacts -> all contacts. Evid: 101.
    
    
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid.
     *
     * pageView - Type: string.
     *
     * tagcount - Type: numeric.
     *
     * tagCount - Type: numeric. Desc: number of tags
     * @param {contactsAllContactsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsAllContacts = function (params) {
        return this.bi.log(__assign({ evid: 101 }, params));
    };
    /**
    * @typedef {Object} contactsFetchContactsFailureParams
    * @property {number} contactsDisplayed - null
    * @property {string} errorReason - error reason
    * @property {string} filterBy - all/label/custom/saved filter
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - metasite id
    * @property {string} pageView - null
    * @property {boolean} usedSearch - T/F
    **/
    /**
     * Name: contacts ->Fetch Contacts - Failure. Evid: 253.
     * Event description: Fetch Contacts - Failure.
    
     * contactsDisplayed - Type: numeric.
     *
     * errorReason - Type: string. Desc: error reason
     *
     * filterBy - Type: string. Desc: all/label/custom/saved filter
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: metasite id
     *
     * pageView - Type: string.
     *
     * usedSearch - Type: bool. Desc: T/F
     * @param {contactsFetchContactsFailureParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsFetchContactsFailure = function (params) {
        return this.bi.log(__assign({ evid: 253 }, params));
    };
    /**
    * @typedef {Object} importContactsGmailRefreshParams
    * @property {string} account_id - null
    * @property {GUID} appstreamid - null
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - null
    * @property {string} origin - The hosting application
    * @property {string} pageView - null
    **/
    /**
     * Name: import contacts -> gmail refresh. Evid: 157.
    
    
     * account_id - Type: string.
     *
     * appstreamid - Type: guid.
     *
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid.
     *
     * origin - Type: string. Desc: The hosting application
     *
     * pageView - Type: string.
     * @param {importContactsGmailRefreshParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.importContactsGmailRefresh = function (params) {
        return this.bi.log(__assign({ evid: 157 }, params));
    };
    /**
    * @typedef {Object} contactsManageContactsTipPresentedParams
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - meta site id
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts -> manage contacts tip presented. Evid: 237.
     * Event description: contacts -> manage contacts tip presented.
    
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: meta site id
     *
     * pageView - Type: string.
     * @param {contactsManageContactsTipPresentedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsManageContactsTipPresented = function (params) {
        return this.bi.log(__assign({ evid: 237 }, params));
    };
    /**
    * @typedef {Object} contactsComponentLoadingTimeParams
    * @property {string} componentName - componentName
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {number} loadingTime - loading_time
    * @property {string} moduleId - moduleId
    * @property {GUID} msid - msid
    * @property {string} pageView - null
    **/
    /**
     * Name: Contacts - component loading time. Evid: 294.
     * Event description: Contacts - component loading time.
    
     * componentName - Type: string. Desc: componentName
     *
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * loadingTime - Type: numeric. Desc: loading_time
     *
     * moduleId - Type: string. Desc: moduleId
     *
     * msid - Type: guid. Desc: msid
     *
     * pageView - Type: string.
     * @param {contactsComponentLoadingTimeParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsComponentLoadingTime = function (params) {
        return this.bi.log(__assign({ evid: 294 }, params));
    };
    /**
    * @typedef {Object} exportContactsChooseTypeOfContactsParams
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - null
    * @property {string} pageView - null
    * @property {string} type - type of chosen
    **/
    /**
     * Name: export contacts -> choose type of contacts. Evid: 164.
     * Event description: choose type of contacts.
    
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid.
     *
     * pageView - Type: string.
     *
     * type - Type: string. Desc: type of chosen
     * @param {exportContactsChooseTypeOfContactsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.exportContactsChooseTypeOfContacts = function (params) {
        return this.bi.log(__assign({ evid: 164 }, params));
    };
    /**
    * @typedef {Object} contactsFullPageMoreActionsParams
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - msid
    * @property {string} pageView - null
    **/
    /**
     * Name: Contacts - Full Page - more actions. Evid: 283.
     * Event description: Contacts - Full Page - more actions.
    
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: msid
     *
     * pageView - Type: string.
     * @param {contactsFullPageMoreActionsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsFullPageMoreActions = function (params) {
        return this.bi.log(__assign({ evid: 283 }, params));
    };
    /**
    * @typedef {Object} contactsOpenManageLabelsDialogParams
    * @property {number} contactsDisplayed - deprecated
    * @property {boolean} hasContacts - deprecated
    * @property {GUID} msid - metasite id
    * @property {string} origin - contacts-list, contact-card-actions, contacts-card-labels
    * @property {string} pageView - deprecated
    **/
    /**
     * Name: contacts -> open manage labels dialog. Evid: 139.
     * Event description: user clicks manage labels and the dialog is opened.
    
     * contactsDisplayed - Type: numeric. Desc: deprecated
     *
     * hasContacts - Type: bool. Desc: deprecated
     *
     * msid - Type: guid. Desc: metasite id
     *
     * origin - Type: string. Desc: contacts-list, contact-card-actions, contacts-card-labels
     *
     * pageView - Type: string. Desc: deprecated
     * @param {contactsOpenManageLabelsDialogParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsOpenManageLabelsDialog = function (params) {
        return this.bi.log(__assign({ evid: 139 }, params));
    };
    /**
    * @typedef {Object} importContactsNoContactFoundPopUpPresentedParams
    * @property {GUID} appstreamid - unique identifier of import session
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - msid
    * @property {string} origin - The hosting application
    * @property {string} package_group - package_group
    * @property {string} package_id - package_name
    * @property {string} pageView - null
    **/
    /**
     * Name: import contacts -> 'No Contact Found' - pop up presented. Evid: 228.
     * Event description: 'No Contact Found' - pop up presented.
    
     * appstreamid - Type: guid. Desc: unique identifier of import session
     *
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: The hosting application
     *
     * package_group - Type: string. Desc: package_group
     *
     * package_id - Type: string. Desc: package_name
     *
     * pageView - Type: string.
     * @param {importContactsNoContactFoundPopUpPresentedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.importContactsNoContactFoundPopUpPresented = function (params) {
        return this.bi.log(__assign({ evid: 228 }, params));
    };
    /**
    * @typedef {Object} contactsImportFromContactsAppEmptyExperienceParams
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - null
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts -> import from contacts app - empty experience. Evid: 114.
    
    
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid.
     *
     * pageView - Type: string.
     * @param {contactsImportFromContactsAppEmptyExperienceParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsImportFromContactsAppEmptyExperience = function (params) {
        return this.bi.log(__assign({ evid: 114 }, params));
    };
    /**
    * @typedef {Object} contactsAdvancedFiltersSavingUpdatingCancellationParams
    * @property {string} action - 'save'/'update'
    * @property {string} cancelType - ‘cancel’/’dismiss’
    * @property {number} contactsDisplayed - null
    * @property {string} filterID - filterID
    * @property {string} filterName - filterName
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - metasite id
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts ->Advanced Filters - saving/updating cancellation. Evid: 257.
     * Event description: saving cancellation on Save/Update pop-up.
    
     * action - Type: string. Desc: 'save'/'update'
     *
     * cancelType - Type: string. Desc: ‘cancel’/’dismiss’
     *
     * contactsDisplayed - Type: numeric.
     *
     * filterID - Type: string. Desc: filterID
     *
     * filterName - Type: string. Desc: filterName
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: metasite id
     *
     * pageView - Type: string.
     * @param {contactsAdvancedFiltersSavingUpdatingCancellationParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsAdvancedFiltersSavingUpdatingCancellation = function (params) {
        return this.bi.log(__assign({ evid: 257 }, params));
    };
    /**
    * @typedef {Object} importContactsCreateCsvFileLearnMoreClickParams
    * @property {GUID} appstreamid - unique identifier of import session
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - msid
    * @property {string} origin - The hosting application
    * @property {string} package_group - package_group
    * @property {string} package_id - package_name
    * @property {string} pageView - null
    * @property {string} phase_name - prepare / upload / match
    **/
    /**
     * Name: import contacts -> create CSV File - Learn More - click. Evid: 209.
     * Event description: create CSV File - Learn More - click.
    
     * appstreamid - Type: guid. Desc: unique identifier of import session
     *
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: The hosting application
     *
     * package_group - Type: string. Desc: package_group
     *
     * package_id - Type: string. Desc: package_name
     *
     * pageView - Type: string.
     *
     * phase_name - Type: string. Desc: prepare / upload / match
     * @param {importContactsCreateCsvFileLearnMoreClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.importContactsCreateCsvFileLearnMoreClick = function (params) {
        return this.bi.log(__assign({ evid: 209 }, params));
    };
    /**
    * @typedef {Object} contactListClickOnDemoVideoParams
    * @property {string} clickOrigin - 'Banner', 'More Actions'
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - msid
    * @property {string} pageView - null
    **/
    /**
     * Name: Contact list - click on Demo video. Evid: 277.
     * Event description: Contact list - click on Demo video banner.
    
     * clickOrigin - Type: string. Desc: 'Banner', 'More Actions'
     *
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: msid
     *
     * pageView - Type: string.
     * @param {contactListClickOnDemoVideoParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactListClickOnDemoVideo = function (params) {
        return this.bi.log(__assign({ evid: 277 }, params));
    };
    /**
    * @typedef {Object} contactsAdvancedFiltersClickAddFilterAddConditionParams
    * @property {number} contactsDisplayed - null
    * @property {string} filterID - filterID
    * @property {string} filterName - filterName
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - metasite id
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts ->Advanced Filters - click Add filter (add condition). Evid: 255.
     * Event description: user click on Add filter (add condition) - in Edit mode of custom filter.
    
     * contactsDisplayed - Type: numeric.
     *
     * filterID - Type: string. Desc: filterID
     *
     * filterName - Type: string. Desc: filterName
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: metasite id
     *
     * pageView - Type: string.
     * @param {contactsAdvancedFiltersClickAddFilterAddConditionParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsAdvancedFiltersClickAddFilterAddCondition = function (params) {
        return this.bi.log(__assign({ evid: 255 }, params));
    };
    /**
    * @typedef {Object} contactsContactPanelClickOnQuickActionButtonParams
    * @property {string} contactId - contact id
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - meta site id
    * @property {string} pageView - crm tab name
    **/
    /**
     * Name: contacts -> contact panel -> click on quick action button. Evid: 204.
     * Event description: user clicks on quick action menu button.
    
     * contactId - Type: string. Desc: contact id
     *
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: meta site id
     *
     * pageView - Type: string. Desc: crm tab name
     * @param {contactsContactPanelClickOnQuickActionButtonParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsContactPanelClickOnQuickActionButton = function (params) {
        return this.bi.log(__assign({ evid: 204 }, params));
    };
    /**
    * @typedef {Object} contactsNoteActionStartParams
    * @property {string} action - add/edit/delete
    * @property {string} category - note category
    * @property {string} contact_id - contact_id
    * @property {number} contactsDisplayed - deprecated
    * @property {boolean} hasContacts - deprecated
    * @property {GUID} ldSessionID - deprecated
    * @property {GUID} msid - msid
    * @property {number} num_of_notes - number of note for contact
    * @property {string} pageView - deprecated
    **/
    /**
     * Name: contacts -> note action start. Evid: 195.
     * Event description: user click on note action.
    
     * action - Type: string. Desc: add/edit/delete
     *
     * category - Type: string. Desc: note category
     *
     * contact_id - Type: string. Desc: contact_id
     *
     * contactsDisplayed - Type: numeric. Desc: deprecated
     *
     * hasContacts - Type: bool. Desc: deprecated
     *
     * ldSessionID - Type: guid. Desc: deprecated
     *
     * msid - Type: guid. Desc: msid
     *
     * num_of_notes - Type: numeric. Desc: number of note for contact
     *
     * pageView - Type: string. Desc: deprecated
     * @param {contactsNoteActionStartParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsNoteActionStart = function (params) {
        return this.bi.log(__assign({ evid: 195 }, params));
    };
    /**
    * @typedef {Object} exportContactsFinishExportFailureParams
    * @property {string} contact_type - chosen/ group
    * @property {number} contactsDisplayed - deprecated
    * @property {string} export_type - export format
    * @property {boolean} hasContacts - deprecated
    * @property {GUID} msid - null
    * @property {string} pageView - deprecated
    * @property {string} source - source
    **/
    /**
     * Name: export contacts -> finish export failure. Evid: 167.
     * Event description: finish export success.
    
     * contact_type - Type: string. Desc: chosen/ group
     *
     * contactsDisplayed - Type: numeric. Desc: deprecated
     *
     * export_type - Type: string. Desc: export format
     *
     * hasContacts - Type: bool. Desc: deprecated
     *
     * msid - Type: guid.
     *
     * pageView - Type: string. Desc: deprecated
     *
     * source - Type: string. Desc: source
     * @param {exportContactsFinishExportFailureParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.exportContactsFinishExportFailure = function (params) {
        return this.bi.log(__assign({ evid: 167 }, params));
    };
    /**
    * @typedef {Object} contactsAdvancedFiltersClickOnFilterByTabParams
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - metasite id
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts -> Advanced Filters - Click on ‘filter by’ dropdown. Evid: 246.
     * Event description: Click on ‘filter by’ dropdown.
    
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: metasite id
     *
     * pageView - Type: string.
     * @param {contactsAdvancedFiltersClickOnFilterByTabParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsAdvancedFiltersClickOnFilterByTab = function (params) {
        return this.bi.log(__assign({ evid: 246 }, params));
    };
    /**
    * @typedef {Object} importContactsClickSelectParams
    * @property {GUID} appstreamid - unique identifier of import session
    * @property {number} contactsDisplayed - null
    * @property {string} context - context
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - null
    * @property {string} origin - The hosting application
    * @property {string} package_group - package_group
    * @property {string} package_id - package_name
    * @property {string} pageView - null
    * @property {string} source - null
    **/
    /**
     * Name: import contacts -> click select. Evid: 200.
     * Event description: click connect in order to connect gmail acount.
    
     * appstreamid - Type: guid. Desc: unique identifier of import session
     *
     * contactsDisplayed - Type: numeric.
     *
     * context - Type: string. Desc: context
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid.
     *
     * origin - Type: string. Desc: The hosting application
     *
     * package_group - Type: string. Desc: package_group
     *
     * package_id - Type: string. Desc: package_name
     *
     * pageView - Type: string.
     *
     * source - Type: string.
     * @param {importContactsClickSelectParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.importContactsClickSelect = function (params) {
        return this.bi.log(__assign({ evid: 200 }, params));
    };
    /**
    * @typedef {Object} importContactsClickOnBackNextStepParams
    * @property {GUID} appstreamid - unique identifier of import session
    * @property {number} contactsDisplayed - null
    * @property {string} direct_from - 'Prepare'/'Upload'/'Match'/'Label'
    * @property {string} direction - 'back'/'next'
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - msid
    * @property {string} origin - The hosting application
    * @property {string} package_group - package_group
    * @property {string} package_id - package_name
    * @property {string} pageView - null
    **/
    /**
     * Name: import contacts -> click on back/ next step  - CSV import. Evid: 229.
     * Event description: click on back/ next step.
    
     * appstreamid - Type: guid. Desc: unique identifier of import session
     *
     * contactsDisplayed - Type: numeric.
     *
     * direct_from - Type: string. Desc: 'Prepare'/'Upload'/'Match'/'Label'
     *
     * direction - Type: string. Desc: 'back'/'next'
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: The hosting application
     *
     * package_group - Type: string. Desc: package_group
     *
     * package_id - Type: string. Desc: package_name
     *
     * pageView - Type: string.
     * @param {importContactsClickOnBackNextStepParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.importContactsClickOnBackNextStep = function (params) {
        return this.bi.log(__assign({ evid: 229 }, params));
    };
    /**
    * @typedef {Object} contactsSiteMembersSignupRequestsParams
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - null
    * @property {string} pageView - null
    * @property {number} tagcount - null
    **/
    /**
     * Name: contacts -> site members -> signup requests. Evid: 106.
    
    
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid.
     *
     * pageView - Type: string.
     *
     * tagcount - Type: numeric.
     * @param {contactsSiteMembersSignupRequestsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsSiteMembersSignupRequests = function (params) {
        return this.bi.log(__assign({ evid: 106 }, params));
    };
    /**
    * @typedef {Object} contactsViewContactDeleteButtonParams
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - null
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts -> view contact -> delete button. Evid: 111.
    
    
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid.
     *
     * pageView - Type: string.
     * @param {contactsViewContactDeleteButtonParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsViewContactDeleteButton = function (params) {
        return this.bi.log(__assign({ evid: 111 }, params));
    };
    /**
    * @typedef {Object} contactsAdvancedFiltersClickOnDeleteFilterParams
    * @property {number} contactsDisplayed - null
    * @property {string} filterID - filterID
    * @property {string} filterName - filterName
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - metasite id
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts ->Advanced Filters - click on Delete filter. Evid: 260.
     * Event description: user click on Delete filter.
    
     * contactsDisplayed - Type: numeric.
     *
     * filterID - Type: string. Desc: filterID
     *
     * filterName - Type: string. Desc: filterName
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: metasite id
     *
     * pageView - Type: string.
     * @param {contactsAdvancedFiltersClickOnDeleteFilterParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsAdvancedFiltersClickOnDeleteFilter = function (params) {
        return this.bi.log(__assign({ evid: 260 }, params));
    };
    /**
    * @typedef {Object} contactsCreateAContactWarningDisplayedParams
    * @property {string} contactId - contact id
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - meta site id
    * @property {string} origin - view contact
    * @property {string} pageView - crm tab name
    **/
    /**
     * Name: contacts -> create a contact-> duplication warning ->click on view contact. Evid: 273.
     * Event description: user clicks on view contact in duplication warning of new contact.
    
     * contactId - Type: string. Desc: contact id
     *
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: meta site id
     *
     * origin - Type: string. Desc: view contact
     *
     * pageView - Type: string. Desc: crm tab name
     * @param {contactsCreateAContactWarningDisplayedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsCreateAContactWarningDisplayed = function (params) {
        return this.bi.log(__assign({ evid: 273 }, params));
    };
    /**
    * @typedef {Object} contactsWidgetOpenContactParams
    * @property {GUID} contactId - contactId
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - msid
    * @property {string} pageView - null
    **/
    /**
     * Name: Contacts - Widget -  Open Contact. Evid: 296.
     * Event description: Contacts - Widget -  Open Contact.
    
     * contactId - Type: guid. Desc: contactId
     *
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: msid
     *
     * pageView - Type: string.
     * @param {contactsWidgetOpenContactParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsWidgetOpenContact = function (params) {
        return this.bi.log(__assign({ evid: 296 }, params));
    };
    /**
    * @typedef {Object} contactsStartFetchingContactsParams
    * @property {number} contactsDisplayed - null
    * @property {string} filterBy - all/label/custom/saved filter
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - metasite id
    * @property {string} pageView - null
    * @property {boolean} usedSearch - T/F
    **/
    /**
     * Name: contacts ->Start Fetching Contacts. Evid: 263.
     * Event description: Start Fetching Contacts.
    
     * contactsDisplayed - Type: numeric.
     *
     * filterBy - Type: string. Desc: all/label/custom/saved filter
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: metasite id
     *
     * pageView - Type: string.
     *
     * usedSearch - Type: bool. Desc: T/F
     * @param {contactsStartFetchingContactsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsStartFetchingContacts = function (params) {
        return this.bi.log(__assign({ evid: 263 }, params));
    };
    /**
    * @typedef {Object} contactsDisplayFirstTimeExperienceParams
    * @property {string} contact_id - contact identifier
    * @property {number} contactsDisplayed - null
    * @property {string} group - the clicked contacts tab
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - null
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts -> Display First Time Experience. Evid: 181.
     * Event description: Display First Time Experience.
    
     * contact_id - Type: string. Desc: contact identifier
     *
     * contactsDisplayed - Type: numeric.
     *
     * group - Type: string. Desc: the clicked contacts tab
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid.
     *
     * pageView - Type: string.
     * @param {contactsDisplayFirstTimeExperienceParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsDisplayFirstTimeExperience = function (params) {
        return this.bi.log(__assign({ evid: 181 }, params));
    };
    /**
    * @typedef {Object} contactsCustomFieldsDeletedCustomFieldConfirmParams
    * @property {number} contactsDisplayed - null
    * @property {string} fieldName - field added
    * @property {string} fieldType - field type
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - site id
    * @property {string} origin - on which view the action was done
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts -> custom fields -> deleted custom field confirm. Evid: 210.
     * Event description: click on delete in custom field confirmation modal.
    
     * contactsDisplayed - Type: numeric.
     *
     * fieldName - Type: string. Desc: field added
     *
     * fieldType - Type: string. Desc: field type
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: site id
     *
     * origin - Type: string. Desc: on which view the action was done
     *
     * pageView - Type: string.
     * @param {contactsCustomFieldsDeletedCustomFieldConfirmParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsCustomFieldsDeletedCustomFieldConfirm = function (params) {
        return this.bi.log(__assign({ evid: 210 }, params));
    };
    /**
    * @typedef {Object} contactsSelectAContactParams
    * @property {number} contactsDisplayed - number of contacts displayed
    * @property {number} count_of_marked - number of selected contacted
    * @property {boolean} hasContacts - deprecated
    * @property {GUID} msid - metasite id
    * @property {string} name - label name
    * @property {string} origin - single-contact/select-all
    * @property {string} pageView - deprecated
    **/
    /**
     * Name: contacts -> select a contact. Evid: 120.
     * Event description: user selects a contact or contacts, which displays actions for them in header.
    
     * contactsDisplayed - Type: numeric. Desc: number of contacts displayed
     *
     * count_of_marked - Type: numeric. Desc: number of selected contacted
     *
     * hasContacts - Type: bool. Desc: deprecated
     *
     * msid - Type: guid. Desc: metasite id
     *
     * name - Type: string. Desc: label name
     *
     * origin - Type: string. Desc: single-contact/select-all
     *
     * pageView - Type: string. Desc: deprecated
     * @param {contactsSelectAContactParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsSelectAContact = function (params) {
        return this.bi.log(__assign({ evid: 120 }, params));
    };
    /**
    * @typedef {Object} contactsSiteMembersSettingsAutomaticParams
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - null
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts -> site members settings -> automatic. Evid: 117.
    
    
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid.
     *
     * pageView - Type: string.
     * @param {contactsSiteMembersSettingsAutomaticParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsSiteMembersSettingsAutomatic = function (params) {
        return this.bi.log(__assign({ evid: 117 }, params));
    };
    /**
    * @typedef {Object} contactsAdvancedFiltersRenameFilterConfirmationParams
    * @property {number} contactsDisplayed - null
    * @property {string} filterID - filterID
    * @property {string} filterName - filterName
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - metasite id
    * @property {string} pageView - pageView
    **/
    /**
     * Name: contacts ->Advanced Filters - rename filter - confirmation. Evid: 268.
     * Event description: rename filter - confirmation.
    
     * contactsDisplayed - Type: numeric.
     *
     * filterID - Type: string. Desc: filterID
     *
     * filterName - Type: string. Desc: filterName
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: metasite id
     *
     * pageView - Type: string. Desc: pageView
     * @param {contactsAdvancedFiltersRenameFilterConfirmationParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsAdvancedFiltersRenameFilterConfirmation = function (params) {
        return this.bi.log(__assign({ evid: 268 }, params));
    };
    /**
    * @typedef {Object} contactsOpenTabParams
    * @property {string} contact_id - contact id
    * @property {number} contactsDisplayed - deprecated
    * @property {string} group - deprecated
    * @property {boolean} hasContacts - deprecated
    * @property {GUID} msid - msid
    * @property {string} name - tab name (orders,engage,contact-nfo...)
    * @property {string} pageView - deprecated
    **/
    /**
     * Name: contacts -> open tab. Evid: 180.
     * Event description: move to a different tab in contact card.
    
     * contact_id - Type: string. Desc: contact id
     *
     * contactsDisplayed - Type: numeric. Desc: deprecated
     *
     * group - Type: string. Desc: deprecated
     *
     * hasContacts - Type: bool. Desc: deprecated
     *
     * msid - Type: guid. Desc: msid
     *
     * name - Type: string. Desc: tab name (orders,engage,contact-nfo...)
     *
     * pageView - Type: string. Desc: deprecated
     * @param {contactsOpenTabParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsOpenTab = function (params) {
        return this.bi.log(__assign({ evid: 180 }, params));
    };
    /**
    * @typedef {Object} contactsRenameLabelConfirmationParams
    * @property {number} contactsDisplayed - deprecated
    * @property {boolean} hasContacts - deprecated
    * @property {GUID} msid - metasite id
    * @property {string} new_name - deprecated
    * @property {string} old_name - deprecated
    * @property {string} origin - deprecated
    * @property {string} page_display - deprecated
    * @property {string} pageView - deprecated
    **/
    /**
     * Name: contacts -> rename label confirmation. Evid: 138.
     * Event description: user clicks apply rename label in manage labels dialog.
    
     * contactsDisplayed - Type: numeric. Desc: deprecated
     *
     * hasContacts - Type: bool. Desc: deprecated
     *
     * msid - Type: guid. Desc: metasite id
     *
     * new_name - Type: string. Desc: deprecated
     *
     * old_name - Type: string. Desc: deprecated
     *
     * origin - Type: string. Desc: deprecated
     *
     * page_display - Type: string. Desc: deprecated
     *
     * pageView - Type: string. Desc: deprecated
     * @param {contactsRenameLabelConfirmationParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsRenameLabelConfirmation = function (params) {
        return this.bi.log(__assign({ evid: 138 }, params));
    };
    /**
    * @typedef {Object} contactsAdvancedFiltersCreateFilterClickOnApplyParams
    * @property {string} action - add condition/update condition
    * @property {string} conditionField - condition_field = 'Email'/'First Name'/...
    * @property {string} conditionOperator - 'contains'/'ends with'....
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - metasite id
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts -> Advanced Filters -Create Filter - click on Apply. Evid: 250.
     * Event description: Create Filter - click on Apply.
    
     * action - Type: string. Desc: add condition/update condition
     *
     * conditionField - Type: string. Desc: condition_field = 'Email'/'First Name'/...
     *
     * conditionOperator - Type: string. Desc: 'contains'/'ends with'....
     *
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: metasite id
     *
     * pageView - Type: string.
     * @param {contactsAdvancedFiltersCreateFilterClickOnApplyParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsAdvancedFiltersCreateFilterClickOnApply = function (params) {
        return this.bi.log(__assign({ evid: 250 }, params));
    };
    /**
    * @typedef {Object} contactsContactViewClickOnAContactIconParams
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - null
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts -> contact view -> click on a contact icon. Evid: 131.
    
    
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid.
     *
     * pageView - Type: string.
     * @param {contactsContactViewClickOnAContactIconParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsContactViewClickOnAContactIcon = function (params) {
        return this.bi.log(__assign({ evid: 131 }, params));
    };
    /**
    * @typedef {Object} contactsClickOnCloseManageContactsBannerParams
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - meta site id
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts -> click on close manage contacts banner. Evid: 239.
     * Event description: click on close manage contacts banner.
    
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: meta site id
     *
     * pageView - Type: string.
     * @param {contactsClickOnCloseManageContactsBannerParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsClickOnCloseManageContactsBanner = function (params) {
        return this.bi.log(__assign({ evid: 239 }, params));
    };
    /**
    * @typedef {Object} importContactsDownloadASampleCsvFileClickParams
    * @property {GUID} appstreamid - unique identifier of import session
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - msid
    * @property {string} origin - The hosting application
    * @property {string} package_group - package_group
    * @property {string} package_id - package_name
    * @property {string} pageView - null
    * @property {string} phase_name - prepare / upload / match
    **/
    /**
     * Name: import contacts -> Download a sample CSV file - click. Evid: 208.
     * Event description: Download a sample CSV file - click.
    
     * appstreamid - Type: guid. Desc: unique identifier of import session
     *
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: The hosting application
     *
     * package_group - Type: string. Desc: package_group
     *
     * package_id - Type: string. Desc: package_name
     *
     * pageView - Type: string.
     *
     * phase_name - Type: string. Desc: prepare / upload / match
     * @param {importContactsDownloadASampleCsvFileClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.importContactsDownloadASampleCsvFileClick = function (params) {
        return this.bi.log(__assign({ evid: 208 }, params));
    };
    /**
    * @typedef {Object} contactsConnectedToGoogleFailureParams
    * @property {string} contact_id - contact identifier
    * @property {number} contactsDisplayed - null
    * @property {string} group - the clicked contacts tab
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - null
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts -> Connected to Google failure. Evid: 185.
     * Event description: Connected to Google failure.
    
     * contact_id - Type: string. Desc: contact identifier
     *
     * contactsDisplayed - Type: numeric.
     *
     * group - Type: string. Desc: the clicked contacts tab
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid.
     *
     * pageView - Type: string.
     * @param {contactsConnectedToGoogleFailureParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsConnectedToGoogleFailure = function (params) {
        return this.bi.log(__assign({ evid: 185 }, params));
    };
    /**
    * @typedef {Object} contactsAdvancedFiltersClickOnConditionSubFilterInOrderToEditParams
    * @property {number} contactsDisplayed - null
    * @property {string} filterID - filterID
    * @property {string} filterName - filterName
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - metasite id
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts ->Advanced Filters - click on condition (sub filter) in order to edit. Evid: 259.
     * Event description: user click on sub filter in order to edit.
    
     * contactsDisplayed - Type: numeric.
     *
     * filterID - Type: string. Desc: filterID
     *
     * filterName - Type: string. Desc: filterName
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: metasite id
     *
     * pageView - Type: string.
     * @param {contactsAdvancedFiltersClickOnConditionSubFilterInOrderToEditParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsAdvancedFiltersClickOnConditionSubFilterInOrderToEdit = function (params) {
        return this.bi.log(__assign({ evid: 259 }, params));
    };
    /**
    * @typedef {Object} contactsSortContactsParams
    * @property {number} contactsDisplayed - null
    * @property {string} direction - asc/ desc
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - msid
    * @property {string} name - the name of the sorted field
    * @property {string} page_display - null
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts -> Sort Contacts. Evid: 170.
     * Event description: sorting.
    
     * contactsDisplayed - Type: numeric.
     *
     * direction - Type: string. Desc: asc/ desc
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: msid
     *
     * name - Type: string. Desc: the name of the sorted field
     *
     * page_display - Type: string.
     *
     * pageView - Type: string.
     * @param {contactsSortContactsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsSortContacts = function (params) {
        return this.bi.log(__assign({ evid: 170 }, params));
    };
    /**
    * @typedef {Object} contactsUploadPhotoUploadedSuccessfullyParams
    * @property {string} contact_id - deprecated
    * @property {GUID} contactId - contact_id
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - meta site id
    * @property {string} pageView - pageView
    **/
    /**
     * Name: contacts - upload photo - uploaded successfully. Evid: 232.
     * Event description: photo - uploaded successfully.
    
     * contact_id - Type: string. Desc: deprecated
     *
     * contactId - Type: guid. Desc: contact_id
     *
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: meta site id
     *
     * pageView - Type: string. Desc: pageView
     * @param {contactsUploadPhotoUploadedSuccessfullyParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsUploadPhotoUploadedSuccessfully = function (params) {
        return this.bi.log(__assign({ evid: 232 }, params));
    };
    /**
    * @typedef {Object} importContactsChooseSourceParams
    * @property {GUID} appstreamid - null
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - null
    * @property {string} origin - The hosting application
    * @property {string} pageView - null
    * @property {string} source - null
    **/
    /**
     * Name: import contacts -> choose source. Evid: 152.
    
    
     * appstreamid - Type: guid.
     *
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid.
     *
     * origin - Type: string. Desc: The hosting application
     *
     * pageView - Type: string.
     *
     * source - Type: string.
     * @param {importContactsChooseSourceParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.importContactsChooseSource = function (params) {
        return this.bi.log(__assign({ evid: 152 }, params));
    };
    /**
    * @typedef {Object} contactsAttachmentsClickOnCtaInDialogParams
    * @property {string} contactId - contact id
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - meta site id
    * @property {string} name - size limit, upload failed, delete
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts -> attachments -> click on cta in dialog. Evid: 216.
     * Event description: user clicks on cta in dialog (size limit warning, upload fail, approve delete).
    
     * contactId - Type: string. Desc: contact id
     *
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: meta site id
     *
     * name - Type: string. Desc: size limit, upload failed, delete
     *
     * pageView - Type: string.
     * @param {contactsAttachmentsClickOnCtaInDialogParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsAttachmentsClickOnCtaInDialog = function (params) {
        return this.bi.log(__assign({ evid: 216 }, params));
    };
    /**
    * @typedef {Object} contactsAddNewContactParams
    * @property {string} clickOrigin - 'manage contacts banner'/'contacts app'
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - null
    * @property {string} origin - origin
    * @property {string} pageView - null
    * @property {string} platform - native\web. null is web
    **/
    /**
     * Name: contacts -> add new contact. Evid: 112.
    
    
     * clickOrigin - Type: string. Desc: 'manage contacts banner'/'contacts app'
     *
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid.
     *
     * origin - Type: string. Desc: origin
     *
     * pageView - Type: string.
     *
     * platform - Type: string. Desc: native\web. null is web
     * @param {contactsAddNewContactParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsAddNewContact = function (params) {
        return this.bi.log(__assign({ evid: 112 }, params));
    };
    /**
    * @typedef {Object} contactsContactPanelSelectFromQuickActionsParams
    * @property {string} action - action selected
    * @property {string} contactId - contact id
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - meta site id
    * @property {string} pageView - crm tab name
    **/
    /**
     * Name: contacts -> contact panel -> select from quick actions. Evid: 199.
     * Event description: user clicks on an action in quick action menu.
    
     * action - Type: string. Desc: action selected
     *
     * contactId - Type: string. Desc: contact id
     *
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: meta site id
     *
     * pageView - Type: string. Desc: crm tab name
     * @param {contactsContactPanelSelectFromQuickActionsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsContactPanelSelectFromQuickActions = function (params) {
        return this.bi.log(__assign({ evid: 199 }, params));
    };
    /**
    * @typedef {Object} contactsNewLabelConfirmationParams
    * @property {number} contactsDisplayed - deprecated
    * @property {boolean} hasContacts - deprecated
    * @property {GUID} msid - msid
    * @property {string} name - name of label
    * @property {string} origin - contacts-list, contact-card, manage-labels
    * @property {string} page_display - deprecated
    * @property {string} pageView - deprecated
    **/
    /**
     * Name: contacts -> new label confirmation. Evid: 136.
     * Event description: new label creation confirm.
    
     * contactsDisplayed - Type: numeric. Desc: deprecated
     *
     * hasContacts - Type: bool. Desc: deprecated
     *
     * msid - Type: guid. Desc: msid
     *
     * name - Type: string. Desc: name of label
     *
     * origin - Type: string. Desc: contacts-list, contact-card, manage-labels
     *
     * page_display - Type: string. Desc: deprecated
     *
     * pageView - Type: string. Desc: deprecated
     * @param {contactsNewLabelConfirmationParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsNewLabelConfirmation = function (params) {
        return this.bi.log(__assign({ evid: 136 }, params));
    };
    /**
    * @typedef {Object} contactsDisplayingATabParams
    * @property {string} contact_id - contact id
    * @property {number} contactsDisplayed - null
    * @property {string} group - group name
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - null
    * @property {string} name - name of tab
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts -> displaying a tab. Evid: 179.
     * Event description: displaying a tab.
    
     * contact_id - Type: string. Desc: contact id
     *
     * contactsDisplayed - Type: numeric.
     *
     * group - Type: string. Desc: group name
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid.
     *
     * name - Type: string. Desc: name of tab
     *
     * pageView - Type: string.
     * @param {contactsDisplayingATabParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsDisplayingATab = function (params) {
        return this.bi.log(__assign({ evid: 179 }, params));
    };
    /**
    * @typedef {Object} exportContactsClickOnStartExportParams
    * @property {string} contact_type - chosen/ group
    * @property {number} contactsDisplayed - deprecated
    * @property {string} export_type - export format
    * @property {boolean} hasContacts - deprecated
    * @property {GUID} msid - null
    * @property {number} number_of_contacts - required contacts to export
    * @property {string} pageView - deprecated
    * @property {string} source - null
    **/
    /**
     * Name: export contacts -> click on start export. Evid: 163.
     * Event description: Correlates to 'save' button in old export.
    
     * contact_type - Type: string. Desc: chosen/ group
     *
     * contactsDisplayed - Type: numeric. Desc: deprecated
     *
     * export_type - Type: string. Desc: export format
     *
     * hasContacts - Type: bool. Desc: deprecated
     *
     * msid - Type: guid.
     *
     * number_of_contacts - Type: numeric. Desc: required contacts to export
     *
     * pageView - Type: string. Desc: deprecated
     *
     * source - Type: string.
     * @param {exportContactsClickOnStartExportParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.exportContactsClickOnStartExport = function (params) {
        return this.bi.log(__assign({ evid: 163 }, params));
    };
    /**
    * @typedef {Object} contactsContactViewAddNewFieldParams
    * @property {number} contactsDisplayed - null
    * @property {string} field - field added
    * @property {string} fieldType - field type
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - null
    * @property {string} origin - what app opened the edit contact modal
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts -> contact view -> added new custom field. Evid: 124.
     * Event description: added new custom field in contacts.
    
     * contactsDisplayed - Type: numeric.
     *
     * field - Type: string. Desc: field added
     *
     * fieldType - Type: string. Desc: field type
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid.
     *
     * origin - Type: string. Desc: what app opened the edit contact modal
     *
     * pageView - Type: string.
     * @param {contactsContactViewAddNewFieldParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsContactViewAddNewField = function (params) {
        return this.bi.log(__assign({ evid: 124 }, params));
    };
    /**
    * @typedef {Object} importContactsViewErrorsParams
    * @property {GUID} appstreamid - unique identifier of import session
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - msid
    * @property {string} origin - The hosting application
    * @property {string} package_group - package_group
    * @property {string} package_id - package_name
    * @property {string} pageView - null
    **/
    /**
     * Name: import contacts -> View Errors. Evid: 226.
     * Event description: user click on 'View errors' after matching fields.
    
     * appstreamid - Type: guid. Desc: unique identifier of import session
     *
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: The hosting application
     *
     * package_group - Type: string. Desc: package_group
     *
     * package_id - Type: string. Desc: package_name
     *
     * pageView - Type: string.
     * @param {importContactsViewErrorsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.importContactsViewErrors = function (params) {
        return this.bi.log(__assign({ evid: 226 }, params));
    };
    /**
    * @typedef {Object} contactsAddImageToContactTipPresentedParams
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - meta site id
    * @property {string} pageView - inbox/ workflows/contacts-list....
    **/
    /**
     * Name: contacts -> 'Add Image to Contact' tip presented. Evid: 240.
     * Event description: contacts -> contacts photo tip presented.
    
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: meta site id
     *
     * pageView - Type: string. Desc: inbox/ workflows/contacts-list....
     * @param {contactsAddImageToContactTipPresentedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsAddImageToContactTipPresented = function (params) {
        return this.bi.log(__assign({ evid: 240 }, params));
    };
    /**
    * @typedef {Object} contactsSiteMembersSettingsCancelParams
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - null
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts -> site members settings -> cancel. Evid: 118.
    
    
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid.
     *
     * pageView - Type: string.
     * @param {contactsSiteMembersSettingsCancelParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsSiteMembersSettingsCancel = function (params) {
        return this.bi.log(__assign({ evid: 118 }, params));
    };
    /**
    * @typedef {Object} contactsColumnsEditColumnsListShownParams
    * @property {number} contactsDisplayed - number of contacts displayed
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - meta site id
    * @property {number} numOfColumns - number of items in columns list
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts -> columns -> edit columns list shown. Evid: 176.
     * Event description: user clicks on the "+" to customize the fields displayed.
    
     * contactsDisplayed - Type: numeric. Desc: number of contacts displayed
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: meta site id
     *
     * numOfColumns - Type: numeric. Desc: number of items in columns list
     *
     * pageView - Type: string.
     * @param {contactsColumnsEditColumnsListShownParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsColumnsEditColumnsListShown = function (params) {
        return this.bi.log(__assign({ evid: 176 }, params));
    };
    /**
    * @typedef {Object} importContactsAutodidactRecognizeOfFileTypeParams
    * @property {GUID} appstreamid - unique identifier of import session
    * @property {number} contactsDisplayed - null
    * @property {string} context - context
    * @property {string} file_name - file_name
    * @property {boolean} hasContacts - null
    * @property {string} header - header of file
    * @property {GUID} msid - null
    * @property {string} origin - The hosting application
    * @property {string} package_group - package_group
    * @property {string} package_id - package_name
    * @property {string} pageView - null
    * @property {string} type_detected - field name
    **/
    /**
     * Name: import contacts ->autodidact recognize of file type. Evid: 203.
     * Event description: when uploading a file, the client automatically find its type..
    
     * appstreamid - Type: guid. Desc: unique identifier of import session
     *
     * contactsDisplayed - Type: numeric.
     *
     * context - Type: string. Desc: context
     *
     * file_name - Type: string. Desc: file_name
     *
     * hasContacts - Type: bool.
     *
     * header - Type: string. Desc: header of file
     *
     * msid - Type: guid.
     *
     * origin - Type: string. Desc: The hosting application
     *
     * package_group - Type: string. Desc: package_group
     *
     * package_id - Type: string. Desc: package_name
     *
     * pageView - Type: string.
     *
     * type_detected - Type: string. Desc: field name
     * @param {importContactsAutodidactRecognizeOfFileTypeParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.importContactsAutodidactRecognizeOfFileType = function (params) {
        return this.bi.log(__assign({ evid: 203 }, params));
    };
    /**
    * @typedef {Object} contactsFiltersContactClickParams
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - null
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts -> filters contact click. Evid: 103.
    
    
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid.
     *
     * pageView - Type: string.
     * @param {contactsFiltersContactClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsFiltersContactClick = function (params) {
        return this.bi.log(__assign({ evid: 103 }, params));
    };
    /**
    * @typedef {Object} contactsAdvancedFiltersCreateFilterClickOnCancelParams
    * @property {string} conditionField - 'Email'/'First Name'/...
    * @property {string} conditionOperator - 'contains'/'ends with'....
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - metasite id
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts -> Advanced Filters -Create Filter - click on cancel. Evid: 251.
     * Event description: Create Filter - click on cancel.
    
     * conditionField - Type: string. Desc: 'Email'/'First Name'/...
     *
     * conditionOperator - Type: string. Desc: 'contains'/'ends with'....
     *
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: metasite id
     *
     * pageView - Type: string.
     * @param {contactsAdvancedFiltersCreateFilterClickOnCancelParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsAdvancedFiltersCreateFilterClickOnCancel = function (params) {
        return this.bi.log(__assign({ evid: 251 }, params));
    };
    /**
    * @typedef {Object} importContactsChooseWixNameOfMappedFieldParams
    * @property {GUID} appstreamid - unique identifier of import session
    * @property {number} contactsDisplayed - null
    * @property {string} context - context
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - null
    * @property {string} origin - The hosting application
    * @property {string} original_file_name - original_file_name
    * @property {string} package_group - package_group
    * @property {string} package_id - package_name
    * @property {string} pageView - null
    * @property {string} source - null
    * @property {string} wix_name - field name
    **/
    /**
     * Name: import contacts -> choose Wix name of mapped field. Evid: 202.
     * Event description: choose the field name from uploaded file in order to name it.
    
     * appstreamid - Type: guid. Desc: unique identifier of import session
     *
     * contactsDisplayed - Type: numeric.
     *
     * context - Type: string. Desc: context
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid.
     *
     * origin - Type: string. Desc: The hosting application
     *
     * original_file_name - Type: string. Desc: original_file_name
     *
     * package_group - Type: string. Desc: package_group
     *
     * package_id - Type: string. Desc: package_name
     *
     * pageView - Type: string.
     *
     * source - Type: string.
     *
     * wix_name - Type: string. Desc: field name
     * @param {importContactsChooseWixNameOfMappedFieldParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.importContactsChooseWixNameOfMappedField = function (params) {
        return this.bi.log(__assign({ evid: 202 }, params));
    };
    /**
    * @typedef {Object} startLoadingContactsAppParams
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - null
    * @property {string} pageView - null
    * @property {string} prev_view - null
    * @property {string} view - null
    **/
    /**
     * Name: start loading contacts app. Evid: 300.
    
    
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid.
     *
     * pageView - Type: string.
     *
     * prev_view - Type: string.
     *
     * view - Type: string.
     * @param {startLoadingContactsAppParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.startLoadingContactsApp = function (params) {
        return this.bi.log(__assign({ evid: 300 }, params));
    };
    /**
    * @typedef {Object} contactsExperienceDisplayedParams
    * @property {number} contactsDisplayed - null
    * @property {number} count - amount of contacts
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - null
    * @property {string} name - of origin
    * @property {string} origin - tag/search/filter
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts -> experience displayed. Evid: 191.
     * Event description: the name of the experience a user see.
    
     * contactsDisplayed - Type: numeric.
     *
     * count - Type: numeric. Desc: amount of contacts
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid.
     *
     * name - Type: string. Desc: of origin
     *
     * origin - Type: string. Desc: tag/search/filter
     *
     * pageView - Type: string.
     * @param {contactsExperienceDisplayedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsExperienceDisplayed = function (params) {
        return this.bi.log(__assign({ evid: 191 }, params));
    };
    /**
    * @typedef {Object} contactsBlockContactParams
    * @property {number} contactsDisplayed - null
    * @property {number} count_of_blocked - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - null
    * @property {string} name - null
    * @property {string} origin - the view on which the action done
    * @property {string} page_display - null
    * @property {string} pageView - null
    * @property {string} place - the actual button that was clicked on the page
    **/
    /**
     * Name: contacts -> block contact. Evid: 149.
     * Event description: when a contact or group of contacts are blocked by the user.
    
     * contactsDisplayed - Type: numeric.
     *
     * count_of_blocked - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid.
     *
     * name - Type: string.
     *
     * origin - Type: string. Desc: the view on which the action done
     *
     * page_display - Type: string.
     *
     * pageView - Type: string.
     *
     * place - Type: string. Desc: the actual button that was clicked on the page
     * @param {contactsBlockContactParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsBlockContact = function (params) {
        return this.bi.log(__assign({ evid: 149 }, params));
    };
    /**
    * @typedef {Object} contactsClickOnClearNewContactParams
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - site guid
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts -> Click on Clear New Contact. Evid: 171.
     * Event description: This button is at the top of Contacts app When you have new contacts It removes the count (marks all as read)..
    
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: site guid
     *
     * pageView - Type: string.
     * @param {contactsClickOnClearNewContactParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsClickOnClearNewContact = function (params) {
        return this.bi.log(__assign({ evid: 171 }, params));
    };
    /**
    * @typedef {Object} contactsDeleteContactParams
    * @property {number} contactsDisplayed - deprecated
    * @property {number} count_of_deleted - deprecated
    * @property {number} count - number of selected contacts
    * @property {boolean} hasContacts - deprecated
    * @property {GUID} msid - metasite id
    * @property {string} name - deprecated
    * @property {string} origin - contact-list, contact-card
    * @property {string} page_display - deprecated
    * @property {string} pageView - deprecated
    **/
    /**
     * Name: contacts -> delete contact. Evid: 148.
     * Event description: user clicks delete (one or more contacts) and approve delete contacts popup is displayed.
    
     * contactsDisplayed - Type: numeric. Desc: deprecated
     *
     * count_of_deleted - Type: numeric. Desc: deprecated
     *
     * count - Type: numeric. Desc: number of selected contacts
     *
     * hasContacts - Type: bool. Desc: deprecated
     *
     * msid - Type: guid. Desc: metasite id
     *
     * name - Type: string. Desc: deprecated
     *
     * origin - Type: string. Desc: contact-list, contact-card
     *
     * page_display - Type: string. Desc: deprecated
     *
     * pageView - Type: string. Desc: deprecated
     * @param {contactsDeleteContactParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsDeleteContact = function (params) {
        return this.bi.log(__assign({ evid: 148 }, params));
    };
    /**
    * @typedef {Object} exportContactsCancelParams
    * @property {number} contactsDisplayed - deprecated
    * @property {boolean} hasContacts - deprecated
    * @property {GUID} msid - null
    * @property {string} pageView - deprecated
    * @property {string} source - null
    **/
    /**
     * Name: export contacts -> cancel. Evid: 162.
    
    
     * contactsDisplayed - Type: numeric. Desc: deprecated
     *
     * hasContacts - Type: bool. Desc: deprecated
     *
     * msid - Type: guid.
     *
     * pageView - Type: string. Desc: deprecated
     *
     * source - Type: string.
     * @param {exportContactsCancelParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.exportContactsCancel = function (params) {
        return this.bi.log(__assign({ evid: 162 }, params));
    };
    /**
    * @typedef {Object} contactsAddNewContactPanelLoadedParams
    * @property {string} app_def_id - deprecated
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - msid
    * @property {string} origin - origin app id
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts -> add new contact - panel loaded. Evid: 206.
     * Event description: add new contact - panel loaded.
    
     * app_def_id - Type: string. Desc: deprecated
     *
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: origin app id
     *
     * pageView - Type: string.
     * @param {contactsAddNewContactPanelLoadedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsAddNewContactPanelLoaded = function (params) {
        return this.bi.log(__assign({ evid: 206 }, params));
    };
    /**
    * @typedef {Object} importContactsLearnMoreParams
    * @property {GUID} appstreamid - unique identifier of import
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - null
    * @property {string} origin - origin of learn more
    * @property {string} package_group - package_group
    * @property {string} package_id - package_id
    * @property {string} pageView - null
    * @property {GUID} context - context
    **/
    /**
     * Name: import contacts -> learn more. Evid: 151.
    
    
     * appstreamid - Type: guid. Desc: unique identifier of import
     *
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid.
     *
     * origin - Type: string. Desc: origin of learn more
     *
     * package_group - Type: string. Desc: package_group
     *
     * package_id - Type: string. Desc: package_id
     *
     * pageView - Type: string.
     *
     * context - Type: guid. Desc: context
     * @param {importContactsLearnMoreParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.importContactsLearnMore = function (params) {
        return this.bi.log(__assign({ evid: 151 }, params));
    };
    /**
    * @typedef {Object} contactsAddNewFieldOpenDropdownParams
    * @property {number} contactsDisplayed - deprecated
    * @property {boolean} hasContacts - deprecated
    * @property {GUID} msid - meta site id
    * @property {string} origin - on which view the action was done
    * @property {string} page_display - null
    * @property {string} pageView - deprecated
    **/
    /**
     * Name: contacts -> add new field - open dropdown. Evid: 169.
     * Event description: user opens “Add New Field” dropdown list to choose field type.
    
     * contactsDisplayed - Type: numeric. Desc: deprecated
     *
     * hasContacts - Type: bool. Desc: deprecated
     *
     * msid - Type: guid. Desc: meta site id
     *
     * origin - Type: string. Desc: on which view the action was done
     *
     * page_display - Type: string.
     *
     * pageView - Type: string. Desc: deprecated
     * @param {contactsAddNewFieldOpenDropdownParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsAddNewFieldOpenDropdown = function (params) {
        return this.bi.log(__assign({ evid: 169 }, params));
    };
    /**
    * @typedef {Object} importContactsAddLabelParams
    * @property {GUID} appstreamid - unique identifier of import session
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {string} import_type - 'gmail account' / 'csv file'
    * @property {string} label_name - label_name
    * @property {GUID} msid - msid
    * @property {string} origin - The hosting application
    * @property {string} package_group - package_group
    * @property {string} package_id - package_name
    * @property {string} pageView - null
    **/
    /**
     * Name: import contacts -> Add Label. Evid: 225.
     * Event description: Add Label.
    
     * appstreamid - Type: guid. Desc: unique identifier of import session
     *
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * import_type - Type: string. Desc: 'gmail account' / 'csv file'
     *
     * label_name - Type: string. Desc: label_name
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: The hosting application
     *
     * package_group - Type: string. Desc: package_group
     *
     * package_id - Type: string. Desc: package_name
     *
     * pageView - Type: string.
     * @param {importContactsAddLabelParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.importContactsAddLabel = function (params) {
        return this.bi.log(__assign({ evid: 225 }, params));
    };
    /**
    * @typedef {Object} contactsAddNewContactEmptyListParams
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - null
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts -> add new contact (empty list). Evid: 113.
    
    
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid.
     *
     * pageView - Type: string.
     * @param {contactsAddNewContactEmptyListParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsAddNewContactEmptyList = function (params) {
        return this.bi.log(__assign({ evid: 113 }, params));
    };
    /**
    * @typedef {Object} contactsFieldActionClickParams
    * @property {string} action - add, rename, delete
    * @property {number} contactsDisplayed - null
    * @property {string} fieldName - field added
    * @property {string} fieldType - field type
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - site id
    * @property {string} origin - on which view the action was done
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts -> field action click. Evid: 168.
     * Event description: click on delete/rename field. For add use evid 27:124.
    
     * action - Type: string. Desc: add, rename, delete
     *
     * contactsDisplayed - Type: numeric.
     *
     * fieldName - Type: string. Desc: field added
     *
     * fieldType - Type: string. Desc: field type
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: site id
     *
     * origin - Type: string. Desc: on which view the action was done
     *
     * pageView - Type: string.
     * @param {contactsFieldActionClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsFieldActionClick = function (params) {
        return this.bi.log(__assign({ evid: 168 }, params));
    };
    /**
    * @typedef {Object} contactsUploadPhotoParams
    * @property {string} action - 'add photo' / 'update photo'
    * @property {string} contact_id - contact_id
    * @property {GUID} contactId - contact_id
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - meta site id
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts - upload photo. Evid: 207.
     * Event description: user click on upload / update photo.
    
     * action - Type: string. Desc: 'add photo' / 'update photo'
     *
     * contact_id - Type: string. Desc: contact_id
     *
     * contactId - Type: guid. Desc: contact_id
     *
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: meta site id
     *
     * pageView - Type: string.
     * @param {contactsUploadPhotoParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsUploadPhoto = function (params) {
        return this.bi.log(__assign({ evid: 207 }, params));
    };
    /**
    * @typedef {Object} contactsAddLabelClickParams
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - msid
    * @property {string} origin - “contact panel”,”full page”
    * @property {string} pageView - null
    **/
    /**
     * Name: Contacts - Add Label click. Evid: 290.
     * Event description: Contacts - Add Label click.
    
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: “contact panel”,”full page”
     *
     * pageView - Type: string.
     * @param {contactsAddLabelClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsAddLabelClick = function (params) {
        return this.bi.log(__assign({ evid: 290 }, params));
    };
    /**
    * @typedef {Object} importContactsGmailOptionSelectedParams
    * @property {GUID} appstreamid - appstreamid
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - msid
    * @property {string} origin - origin
    * @property {string} pageView - null
    * @property {string} toggleName - 'All','Label'
    **/
    /**
     * Name: import contacts -> Gmail option selected. Evid: 279.
     * Event description: import contacts -> Gmail option selected.
    
     * appstreamid - Type: guid. Desc: appstreamid
     *
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: origin
     *
     * pageView - Type: string.
     *
     * toggleName - Type: string. Desc: 'All','Label'
     * @param {importContactsGmailOptionSelectedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.importContactsGmailOptionSelected = function (params) {
        return this.bi.log(__assign({ evid: 279 }, params));
    };
    /**
    * @typedef {Object} contactsColumnsEditColumnsListClickDoneParams
    * @property {number} contactsDisplayed - number of contacts displayed
    * @property {string} displayName - which list of contacts is displayed (all contact
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - meta site id
    * @property {number} numOfColumns - number of items in columns list
    * @property {string} pageView - null
    **/
    /**
     * Name: contacts -> columns -> edit columns list click done. Evid: 177.
     * Event description: user clicks done after choosing columns to display.
    
     * contactsDisplayed - Type: numeric. Desc: number of contacts displayed
     *
     * displayName - Type: string. Desc: which list of contacts is displayed (all contact
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: meta site id
     *
     * numOfColumns - Type: numeric. Desc: number of items in columns list
     *
     * pageView - Type: string.
     * @param {contactsColumnsEditColumnsListClickDoneParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsColumnsEditColumnsListClickDone = function (params) {
        return this.bi.log(__assign({ evid: 177 }, params));
    };
    /**
    * @typedef {Object} contactsSendReplyParams
    * @property {string} contact_id - contact identifier
    * @property {number} contactsDisplayed - null
    * @property {string} group - the clicked contacts tab
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - null
    * @property {string} pageView - null
    * @property {number} textLength - how much text he wrote down in the reply
    **/
    /**
     * Name: contacts -> Send Reply. Evid: 190.
     * Event description: Send Reply.
    
     * contact_id - Type: string. Desc: contact identifier
     *
     * contactsDisplayed - Type: numeric.
     *
     * group - Type: string. Desc: the clicked contacts tab
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid.
     *
     * pageView - Type: string.
     *
     * textLength - Type: numeric. Desc: how much text he wrote down in the reply
     * @param {contactsSendReplyParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsSendReply = function (params) {
        return this.bi.log(__assign({ evid: 190 }, params));
    };
    /**
    * @typedef {Object} contactsSearchFieldParams
    * @property {number} contactsDisplayed - number of contacts displayed
    * @property {boolean} hasContacts - if has contacts
    * @property {GUID} msid - metasite id
    * @property {string} pageView - deprecated
    **/
    /**
     * Name: contacts -> search field. Evid: 110.
    
    
     * contactsDisplayed - Type: numeric. Desc: number of contacts displayed
     *
     * hasContacts - Type: bool. Desc: if has contacts
     *
     * msid - Type: guid. Desc: metasite id
     *
     * pageView - Type: string. Desc: deprecated
     * @param {contactsSearchFieldParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsSearchField = function (params) {
        return this.bi.log(__assign({ evid: 110 }, params));
    };
    /**
    * @typedef {Object} contactsFullPageAvatarClickParams
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - msid
    * @property {string} pageView - null
    **/
    /**
     * Name: Contacts - Full Page - avatar click. Evid: 285.
     * Event description: Contacts - Full Page - avatar click.
    
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: msid
     *
     * pageView - Type: string.
     * @param {contactsFullPageAvatarClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsFullPageAvatarClick = function (params) {
        return this.bi.log(__assign({ evid: 285 }, params));
    };
    /**
    * @typedef {Object} contactsFilterContactsByLabelParams
    * @property {number} contactsDisplayed - number of contacts displayed
    * @property {string} filterBy - 'all','label','saved filter'
    * @property {boolean} hasContacts - if has contacts
    * @property {GUID} msid - metasite id
    * @property {string} name - the label's name
    * @property {string} pageView - deprecated
    **/
    /**
     * Name: contacts -> filter contacts. Evid: 100.
     * Event description: user filtered the displayed contacts by choosing a label.
    
     * contactsDisplayed - Type: numeric. Desc: number of contacts displayed
     *
     * filterBy - Type: string. Desc: 'all','label','saved filter'
     *
     * hasContacts - Type: bool. Desc: if has contacts
     *
     * msid - Type: guid. Desc: metasite id
     *
     * name - Type: string. Desc: the label's name
     *
     * pageView - Type: string. Desc: deprecated
     * @param {contactsFilterContactsByLabelParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsFilterContactsByLabel = function (params) {
        return this.bi.log(__assign({ evid: 100 }, params));
    };
    /**
    * @typedef {Object} importContactsClickConnectParams
    * @property {GUID} appstreamid - unique identifier of import session
    * @property {number} contactsDisplayed - null
    * @property {string} context - context
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - null
    * @property {string} origin - The hosting application
    * @property {string} package_group - package_group
    * @property {string} package_id - package_name
    * @property {string} pageView - null
    **/
    /**
     * Name: import contacts -> click connect. Evid: 158.
     * Event description: click connect in order to connect gmail acount.
    
     * appstreamid - Type: guid. Desc: unique identifier of import session
     *
     * contactsDisplayed - Type: numeric.
     *
     * context - Type: string. Desc: context
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid.
     *
     * origin - Type: string. Desc: The hosting application
     *
     * package_group - Type: string. Desc: package_group
     *
     * package_id - Type: string. Desc: package_name
     *
     * pageView - Type: string.
     * @param {importContactsClickConnectParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.importContactsClickConnect = function (params) {
        return this.bi.log(__assign({ evid: 158 }, params));
    };
    /**
    * @typedef {Object} contactsFullPageSendMessageParams
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - msid
    * @property {string} pageView - null
    **/
    /**
     * Name: Contacts - Full Page - Send message. Evid: 287.
     * Event description: Contacts - Full Page - Send message.
    
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid. Desc: msid
     *
     * pageView - Type: string.
     * @param {contactsFullPageSendMessageParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsFullPageSendMessage = function (params) {
        return this.bi.log(__assign({ evid: 287 }, params));
    };
    /**
    * @typedef {Object} contactsEditContactSettingsPopupParams
    * @property {number} contactsDisplayed - null
    * @property {boolean} editable - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - null
    * @property {string} pageView - null
    * @property {string} type - null
    **/
    /**
     * Name: contacts -> edit contact -> settings popup. Evid: 125.
    
    
     * contactsDisplayed - Type: numeric.
     *
     * editable - Type: bool.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid.
     *
     * pageView - Type: string.
     *
     * type - Type: string.
     * @param {contactsEditContactSettingsPopupParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsEditContactSettingsPopup = function (params) {
        return this.bi.log(__assign({ evid: 125 }, params));
    };
    /**
    * @typedef {Object} contactsEditContactCustomerSettingsPopupParams
    * @property {number} contactsDisplayed - null
    * @property {boolean} hasContacts - null
    * @property {GUID} msid - null
    * @property {string} pageView - null
    * @property {string} type - null
    **/
    /**
     * Name: contacts -> edit contact -> customer settings popup. Evid: 127.
    
    
     * contactsDisplayed - Type: numeric.
     *
     * hasContacts - Type: bool.
     *
     * msid - Type: guid.
     *
     * pageView - Type: string.
     *
     * type - Type: string.
     * @param {contactsEditContactCustomerSettingsPopupParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsEditContactCustomerSettingsPopup = function (params) {
        return this.bi.log(__assign({ evid: 127 }, params));
    };
    /**
    * @typedef {Object} contactsAddRemoveLabelsApplyParams
    * @property {number} contactsDisplayed - deprecated
    * @property {number} count - deprecated
    * @property {boolean} hasContacts - deprecated
    * @property {GUID} msid - metasite id
    * @property {string} origin - contacts-list, contact-card
    * @property {string} page_display - deprecated
    * @property {string} pageView - deprecated
    **/
    /**
     * Name: contacts -> add/remove labels apply. Evid: 143.
     * Event description: user clicks apply to changes in labels for contact/s.
    
     * contactsDisplayed - Type: numeric. Desc: deprecated
     *
     * count - Type: numeric. Desc: deprecated
     *
     * hasContacts - Type: bool. Desc: deprecated
     *
     * msid - Type: guid. Desc: metasite id
     *
     * origin - Type: string. Desc: contacts-list, contact-card
     *
     * page_display - Type: string. Desc: deprecated
     *
     * pageView - Type: string. Desc: deprecated
     * @param {contactsAddRemoveLabelsApplyParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.contactsAddRemoveLabelsApply = function (params) {
        return this.bi.log(__assign({ evid: 143 }, params));
    };
    return Logger;
}());
exports.Logger = Logger;
exports.default = init;
function getLoggerConf() {
    return {
        src: 27,
        endpoint: 'contacts'
    };
}
exports.getLoggerConf = getLoggerConf;
//# sourceMappingURL=index.js.map